import { ActivatedRoute, Router } from '@angular/router';
import { AdmService } from '../../../shared/services/adm.service';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ClasePorEstado, isMobile, isMobileXL, loadData, scrollToInvalidFromControls } from 'src/app/shared/utils/helpers';
import { ComentarioPedidoDialogComponent } from 'src/app/shared/components/comentario-pedido-dialog/comentario-pedido-dialog.component';
import { Compania } from 'src/app/shared/models/compania';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { Cuenta } from 'src/app/shared/models/cuenta';
import { CuentaDistribuidor } from 'src/app/shared/models/cuentaDistribuidor';
import { DataClientePedidos } from 'src/app/shared/models/dataClientePedidos';
import { DatePipe, DecimalPipe } from '@angular/common'
import { debounceTime, distinctUntilChanged, filter, finalize, forkJoin, map, Observable, startWith, switchMap, tap } from 'rxjs';
import { Direccion } from 'src/app/shared/models/direccion';
import { Division } from 'src/app/shared/models/division';
import { Factura } from 'src/app/shared/models/factura';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { GrupoCliente } from 'src/app/shared/models/grupoCliente';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { ListaPrecioCabecera } from 'src/app/shared/models/listaPrecioCabecera';
import { ListaPrecioItem } from 'src/app/shared/models/listaPrecioItem';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Moneda } from 'src/app/shared/models/moneda';
import { MotivoDevolucionNC } from 'src/app/shared/models/motivoDevolucionNC';
import { NotaCreditoCabecera } from 'src/app/shared/models/notaCreditoCabecera';
import { NotaCreditoFactura } from 'src/app/shared/models/notaCreditoFactura';
import { NotaCreditoItem } from 'src/app/shared/models/notaCreditoItem';
import { NotaCreditoRemito } from 'src/app/shared/models/notaCreditoRemito';
import { ParametrosService } from 'src/app/shared/services/parametros.service';
import { PedidoCabecera } from 'src/app/shared/models/pedidoCabecera';
import { PedidoVentaCabecera } from 'src/app/shared/models/pedidoVentaCabecera';
import { PedidoVentaItem } from 'src/app/shared/models/pedidoVentaItem';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { PVService } from 'src/app/shared/services/pv.service';
import { Region } from 'src/app/shared/models/region';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { Stock } from 'src/app/shared/models/stock';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { TerminoPago } from 'src/app/shared/models/terminoPago';
import { TipoNC } from 'src/app/shared/models/tipoNC';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';
import { ZonaVendedor } from 'src/app/shared/models/zonaVendedor';
import { CotizacionCabecera } from 'src/app/shared/models/cotizacionCabecera';
import { CotizacionItem } from 'src/app/shared/models/cotizacionItem';
import { CotizacionesService } from 'src/app/shared/services/cotizaciones.service';
import { CotizacionItemDescuento } from 'src/app/shared/models/cotizacionItemDescuento';
import { PEPService } from 'src/app/shared/services/pep.service';
import { Deposito } from 'src/app/shared/models/deposito';
import { UbicacionAlmacenamiento } from 'src/app/shared/models/ubicacionAlmacenamiento';
import { CotizacionItemDialogComponent } from './cotizacion-item-dialog.component';
import { CotizacionRetencionesDialogComponent } from './cotizacion-retenciones-dialog.component';
import { CotizacionLogsDialogComponent } from './cotizacion-logs-dialog.component';
import { CotizacionAprobacionRetenidaDialogComponent } from './cotizacion-aprobacion-retenida-dialog.component';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { ImageService } from 'src/app/shared/services/image.service';
import { TipoCambio } from 'src/app/shared/models/tipoCambio';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NroOCDialogComponent } from 'src/app/shared/components/nrooc-dialog/nrooc-dialog.component';
import { CotizacionRetencion } from 'src/app/shared/models/cotizacionRetencion';


@Component({
  selector: 'app-cotizacion',
  templateUrl: './cotizacion.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class CotizacionComponent {

  userName: string = "";

  @ViewChild('cotizacion') cotizacion: ElementRef;
  @ViewChild('top') top: ElementRef;

  mesAnioPrimerCuotaPlanta: string = "";
  mesAnioSegundaCuotaPlanta: string = "";
  mesAnioTercerCuotaPlanta: string = "";
  mesAnioPrimerCuotaDistribuidor: string = "";
  mesAnioSegundaCuotaDistribuidor: string = "";
  mesAnioTercerCuotaDistribuidor: string = "";

  dataSourceItems = new MatTableDataSource<CotizacionItem>();
  dataSourceItemsDescuentos = new MatTableDataSource<CotizacionItemDescuento>();
  // dataSourceItemsDescuentos = new MatTableDataSource(element.itemsDescuentos);
  @ViewChild('matPaginatorItems') matPaginatorItems: MatPaginator;
  @ViewChild('matPaginatorItemsDescuentos') matPaginatorItemsDescuentos: MatPaginator;
  @ViewChild('matSortItems') matSortItems: MatSort;
  @ViewChild('matSortItemsDescuentos') matSortItemsDescuentos: MatSort;
  displayedColumnsItems = ['acciones', 'nroLinea', 'fechaEntrega', 'idProducto', 'producto', 'cantidad', 'itemDistribuidor', 'itemPlanta', 'precioUnitarioLista', 'totalDescuento', 'recargo', 'totalPrecioKGL', 'total', 'expand']
  displayedColumnsItemsDescuentos: string[] = ['idTipoCondicion', 'tipoCondicion', 'importe', 'porcentaje', 'descuento'];

  columnsToDisplayWithExpand = [...this.displayedColumnsItems, 'expand'];
  expandedElement: any | null = null;
  dataSourceItemsDescuentosFiltrados = new MatTableDataSource([]);
  totalDesc: number = 0

  retenciones: CotizacionRetencion[] = []

  toggleExpandRow(element: any) {
    this.expandedElement = this.expandedElement === element ? null : element;

    if (this.expandedElement) {
      // Filtrar descuentos que coincidan con el producto seleccionado
      this.dataSourceItemsDescuentosFiltrados.data = this.dataSourceItemsDescuentos.data.filter(
        (desc) => desc.idProducto === element.idProducto
      );
      this.totalDesc = this.dataSourceItemsDescuentosFiltrados.data.map(a => a.descuento).reduce(function (a, b) {
        return a + b;
      });
      console.log(this.totalDesc)
    } else {
      this.dataSourceItemsDescuentosFiltrados.data = [];
    }
  }



  toggleExpand(element: any, event: Event) {
    event.stopPropagation();
    this.expandedElement = this.expandedElement === element ? null : element;
  }
  isExpanded = (index: number, row: any) => row === this.expandedElement;


  aviso: boolean = false;
  avisoUnidadesPallet: boolean = false;
  mensajeUnidadesPallet: string;
  avisoUnidadesPalletDistribuidor: boolean = false;
  mensajeUnidadesPalletDistribuidor: string;
  avisoUnidadesPalletDistribuidorPrimerCuota: boolean = false;
  mensajeUnidadesPalletDistribuidorPrimerCuota: string;
  avisoUnidadesPalletDistribuidorSegundaCuota: boolean = false;
  mensajeUnidadesPalletDistribuidorSegundaCuota: string;
  avisoUnidadesPalletDistribuidorTercerCuota: boolean = false;
  mensajeUnidadesPalletDistribuidorTercerCuota: string;
  avisoUnidadesPalletPlanta: boolean = false;
  mensajeUnidadesPalletPlanta: string;
  avisoUnidadesPalletPlantaPrimerCuota: boolean = false;
  mensajeUnidadesPalletPlantaPrimerCuota: string;
  avisoUnidadesPalletPlantaSegundaCuota: boolean = false;
  mensajeUnidadesPalletPlantaSegundaCuota: string;
  avisoUnidadesPalletPlantaTercerCuota: boolean = false;
  mensajeUnidadesPalletPlantaTercerCuota: string;

  descuentosDiscrecionalesNegativos: boolean = false;
  itemsConDescuentoDiscrecionalNegativo: CotizacionItem[] = [];
  idTipo: number = 0;
  totalItems: number = 0;
  avisoCreditoVencido: boolean = false;
  mensajeDeudaVencida: string = "";
  mensajeCreditoExcedido: string = "";
  credito: number = null;
  codigoEdit: number = 0;
  companias: Compania[] = [];
  direcciones: Cuenta[] = [];
  direccionSeleccionada: Cuenta;
  cuentasDistribuidores: CuentaDistribuidor[] = []; //Dorados
  ctaDistrubuidorSeleccionada: CuentaDistribuidor;
  divisiones: Division[] = [];
  divisionSeleccionada: Division;
  edicion: boolean;
  gcs: GrupoCliente[] = [];
  gcSeleccionado: GrupoCliente;
  monedas: Moneda[] = [];
  motivosRetencion: ItemParametro[] = [];
  disclaimersCotizaciones: ItemParametro[] = [];
  diasCotizacionRechazada: ItemParametro;
  cabForm: FormGroup;
  itemForm: FormGroup;
  regiones: Region[] = [];
  rolesConRegion: ItemParametro[] = [];
  salesOrgs: SalesOrg[] = [];
  selectRegiones: boolean = true;
  terminosPago: TerminoPago[] = [];
  tpSeleccionado: TerminoPago;
  cab: CotizacionCabecera;
  regionSeleccionada: Region;
  monedaSeleccionada: Moneda;
  salesOrgSeleccionada: SalesOrg;
  companiaSeleccionada: Compania;
  alta: boolean = false;
  plantaSeleccionada: Deposito;
  plantaItemSeleccionada: Deposito;
  storageLocationSeleccionado: UbicacionAlmacenamiento;
  storagesLocations: UbicacionAlmacenamiento[] = [];
  slSeleccionado: UbicacionAlmacenamiento;
  dirEntregas: Direccion[] = [];
  dirEntregaSeleccionada: Direccion;
  plantas: Deposito[] = [];
  cantidadCompradaAcumuldada: number = 0;
  plantasItem: Deposito[] = [];
  minDate: Date;
  lps: ListaPrecioCabecera[] = [];

  minDateFechaEntregaPrimerCuota: Date;
  minDateFechaEntregaSegundaCuota: Date
  minDateFechaEntregaTercerCuota: Date

  //#region autocomplete Cliente

  clientesEncontrados: any;
  clienteSeleccionado: Cuenta;
  fcAutocompleteCliente = new FormControl('');
  hintC: string = ""
  loadingFcAutocompleteCliente = false;
  minLengthTermCliente = 2;

  //#endregion

  //#region autocomplete ZonaVendedor

  zvsEncontradas: any;
  zvSeleccionada: ZonaVendedor;
  fcAutocompleteZv = new FormControl('');
  hintZV: string = ""
  loadingFcAutocompleteZV = false;
  minLengthTermZV = 2;

  //#endregion

  //#region autocomplete Lista precios

  lpsEncontradas: any;
  lpSeleccionada: ListaPrecioCabecera;
  fcAutocompleteLP = new FormControl('');
  hintLP: string = ""
  loadingFcAutocompleteLP = false;
  minLengthTermLP = 2;

  //#endregion

  //#region autocomplete Ítem

  itemsEncontrados: any;
  itemSeleccionado: ListaPrecioItem;
  fcAutocompleteItem = new FormControl('');
  hintItem: string = ""
  loadingFcAutocompleteItem = false;
  minLengthTermItem = 1;

  paramCodigo: string = "";

  //#endregion


  constructor(
    private admService: AdmService,
    private cd: ChangeDetectorRef,
    private configService: ConfigService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private parametrosService: ParametrosService,
    private productosService: ProductosService,
    private cotizacionesService: CotizacionesService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private pepService: PEPService,
    private tablasService: TablasService,
    private activatedRoute: ActivatedRoute,
    private usuarioService: UsuariosService,
    private imageService: ImageService,

  ) {



    this.cabForm = this.fb.group({
      calleNroDireccionEntrega: [''],
      ciudadDireccionEntrega: [''],
      nombreClienteDireccionEntrega: [''],
      nroClienteDireccionEntrega: ['', Validators.required],
      cpDireccionEntrega: [''],
      idSalesOffice: [''],
      codigosRetencionesAprobadas: [[]],
      aplicaDescDisc: [false],
      aplicaDtoDiscrecionalxLP: [false],
      aplicaPrecioFijoxLP: [false],
      aprobar: [false],
      aprobarParcial: [false],
      aprobarReservado: [false],
      borrador: [false],
      autor: [''],
      comentario: [''],
      comentarioLogAutorizacion: [''],
      cuit: [''],
      descuentoCategoria: [0],
      descuentoDiscrecional: [0],
      direccion: [''],
      estado: ['Borrador'],
      fechaCreacion: [new Date()],
      glosa: [''],
      habilitacion: [true],
      idCompania: [''],
      compania: [''],
      idDescuento: [''],
      descuento: [''],
      idPais: [''],
      idSalesOrg: [''],
      salesOrg: [''],
      idDivision: ['', Validators.required],
      division: [''],
      idEstado: [1],
      idGrupoCliente: ['', Validators.required],
      grupoCliente: [''],
      idMoneda: ['', Validators.required],
      idMotivoRetencion: [''],
      idRegion: ['', Validators.required],
      idSucursal: ['', Validators.required],
      idTaxClassification: [''],
      idTerminoPago: ['', Validators.required],
      idTipoListaPrecios: ['', Validators.required],
      idTipoOrden: ['12'],
      tipoOrden: ['Cotización'],
      idZonaVendedor: ['', Validators.required],
      items: [[]],
      itemsDescuento: [[]],
      mensajeIntegracion: [''],
      moneda: [''],
      motivoRetencion: [''],
      nombreCliente: [''],
      nombreDistribuidor: [''],
      nroCliente: ['', Validators.required],
      nroClienteDistribuidor: ['', Validators.required], //nroCLiente del distribuidor seleccionado
      nroOrdenSAP: [0],
      nroPedido: [0],
      preciosFijos: [false],
      recargo: [0],
      recargoLocal: [0],
      rechazar: [false],
      reenviar: [false],
      rolUsuarioSolicitante: [''],
      region: [''],
      sFechaCreacion: [this.datePipe.transform(new Date(), 'dd/MM/yyyy')],
      solicitante: [''],
      sucursal: [''],
      terminoPago: [''],
      tipoListaPrecios: [''],
      transferir: [false],
      usuarioRedSolicitante: [''],
      usuarioRedZonaVendedor: [''],
      idPlanta: ['', Validators.required],
      planta: [''],
      codigo: [0],
      email: ['', [Validators.required, Validators.email]],
      emailOpcional: ['', Validators.email],
      tipoCambio: [0],
      fechaPrecio: [new Date()],
      nombreVendedor: [''],
      fechaEntrega: [null],
      nroOC: ['']
    })

    this.itemForm = this.fb.group({

      autor: [''],

      cantidadComprada: [null, [Validators.required, Validators.min(0.001)]],
      //Cantidades disponibles (read only)
      cantDispDistribuidor: [0],
      cantDispDistribuidorPrimerCuota: [0],
      cantDispDistribuidorSegundaCuota: [0],
      cantDispDistribuidorTercerCuota: [0],
      cantDispPlantaPrimerCuota: [0],
      cantDispPlantaSegundaCuota: [0],
      cantDispPlantaTercerCuota: [0],
      //Cantidades que se van a pedir (campos editables)
      cantidadDistribuidor: [0, [Validators.max(0)]], //Cuando se elija un item este validador se actualiza
      cantDistribuidorPrimerCuota: [0, [Validators.max(0)]],
      cantDistribuidorSegundaCuota: [0, [Validators.max(0)]],
      cantDistribuidorTercerCuota: [0, [Validators.max(0)]],
      cantidadPlanta: [0],
      cantPlantaPrimerCuota: [0, [Validators.max(0)]],
      cantPlantaSegundaCuota: [0, [Validators.max(0)]],
      cantPlantaTercerCuota: [0, [Validators.max(0)]],
      //Fechas de las cuotas
      fechaPrimerCuotaDistribuidor: [],
      fechaSegundaCuotaDistribuidor: [],
      fechaTercerCuotaDistribuidor: [],
      fechaPrimerCuotaPlanta: [new Date()],
      fechaSegundaCuotaPlanta: [new Date()],
      fechaTercerCuotaPlanta: [new Date()],
      entregaAFuturo: [false],

      cultivo: [''],
      descuentoCategoria: [0],
      descuentoDiscrecional: [0],
      fechaCreacion: [new Date()],
      fechaActualizacion: [new Date()],
      habilitacion: [true],
      idCompania: [''],
      idCultivo: [''],
      idDivision: [''],
      idLote: [''],
      idPais: [''],
      idPlanta: ['', Validators.required],
      idUbicacionAlmacenamiento: ['', Validators.required],
      idProducto: ['', Validators.required],
      idSalesOrg: [''],
      idTipoOrden: ['12'],
      nroLinea: [0],
      nroPedido: [0],
      porcentajeRecargo: [0],
      precioFinal: [0],
      precioKGL: [0],
      precioUnitarioFinal: [0],
      precioUnitarioLista: [0],
      producto: ['', Validators.required],
      planta: [''],
      recargo: [0],
      recargoLocal: [0],
      tipoOrden: ['Cotización'],
      total: [0],
      totalDescuento: [0],
      totalLocal: [0],
      totalPrecioKGL: [0],
      codigo: [0]
    })

  }


  public Tooltips: {
    Eliminar: string
    Editar: string
    Ver: string;
  }

  public Validaciones: {
    Cantidad: string,
    CantidadComprada: string,
    CantidadRequerida: string,
    Cliente: string,
    DireccionEntrega: string,
    IdSucursal: string,
    ListaPrecios: string,
    ZonaVendedor: string,
    NroClienteDistribuidor: string,
    IdRegion: string,
    IdMoneda: string,
    IdDivision: string,
    IdGrupoCliente: string,
    IdTerminoPago: string,
    IdPlanta: string,
    StorageLocation: string,
    Email: string
    NroOC: string
    FechaEntrega: string
  }


  public Mensajes: {
    CreditoVencido: string,
    DescuentosNegativos: string,
  }

  public Etiquetas: {
    Fecha: string,
    FechaVencimiento: string,
    CantidadDisponibleCuota: string,
    TotalFactura: string,
    FechaEntrega: string,
    ItemPlanta: string,
    ItemDistribuidor: string,
    Acciones: string,
    Buscar: string,
    CalleNroDireccionEntrega: string,
    CantidadProgramada: string,
    CantidadComprada: string,
    CantidadDisponible: string,
    Cantidad: string,
    NombreClienteDireccionEntrega: string,
    NroClienteDireccionEntrega: string,
    CiudadDireccionEntrega: string,
    CantidadRequerida: string,
    CPDireccionEntrega: string,
    StorageLocation: string
    Cliente: string,
    Comentario: string,
    Compania: string,
    CuentaDistribuidor: string,
    CuitCliente: string,
    DescripcionItemDescuento: string,
    Descuento: string
    DescuentoCategoria: string,
    DescuentoDiscrecional: string,
    Direccion: string,
    DireccionEntrega: string,
    Division: string,
    Estado: string,
    FechaCreacion: string,
    FechaDesde: string,
    FechaEstado: string,
    FechaHasta: string,
    Glosa: string,
    IdGrupoCliente: string,
    IdLote: string,
    IdMoneda: string,
    IdProducto: string,
    IdTaxClassification: string,
    IdTipoCondicion: string,
    IdTipoListaPrecios: string,
    Importe: string,
    Item: string,
    MensajeIntegracion: string,
    MotivoRetencion: string,
    NombreCliente: string,
    NombreDistribuidor: string,
    NroCliente: string
    NroFactura: string,
    NroLinea: string,
    NroOrdenSAP: string
    NroPedido: string;
    NroRemito: string,
    Path: string,
    Porcentaje: string,
    PrecioKGL: string,
    PrecioUnitarioFinal: string,
    PrecioUnitarioLista: string,
    Producto: string,
    Recargo: string,
    Region: string,
    SalesOrg: string,
    SinRegistros: string
    Planta: string
    TerminoPago: string,
    TipoEntrega: string,
    TipoListaPrecios: string,
    TipoOrden: string,
    Titulo: string
    Total: string,
    TotalDescuento: string,
    TotalLocal: string,
    TotalPrecioKGL: string,
    ZonaVendedor: string,
    ZonaVendedorSeleccionada: string,
    Email: string
    SalesOffice: string
    EmailOpcional: string
    FechaPrecio: string
    Descuentos: string
    NroOC: string
    NroCotizacion: string

  }

  ngAfterViewInit() {

    this.dataSourceItems.paginator = this.matPaginatorItems;
    this.dataSourceItems.sort = this.matSortItems;
    this.dataSourceItems.sort.disableClear = true;
    this.dataSourceItemsDescuentos.paginator = this.matPaginatorItemsDescuentos;
    this.dataSourceItemsDescuentos.sort = this.matSortItemsDescuentos;
    this.dataSourceItemsDescuentos.sort.disableClear = true;

  }

  ngOnInit() {


    this.activatedRoute.queryParams.subscribe(params => {
      this.paramCodigo = params.codigo;
      if (typeof this.paramCodigo == 'undefined' || typeof params.idTipo == 'undefined') {
        this.volver();
      }

      if (this.paramCodigo.length) {
        if (!isNaN(+this.paramCodigo)) {

          this.codigoEdit = parseInt(this.paramCodigo);
        }
      }

      if (params.idTipo.length) {
        if (!isNaN(+params.idTipo)) {

          this.idTipo = parseInt(params.idTipo);
        }
      }

    });

    this.Tooltips = {
      Editar: this.configService.tooltips.Editar,
      Eliminar: this.configService.tooltips.Eliminar,
      Ver: this.configService.tooltips.Ver
    }

    this.Validaciones = {
      Cantidad: this.configService.validaciones.Cantidad,
      CantidadComprada: this.configService.validaciones.CantidadComprada,
      Cliente: this.configService.validaciones.Cliente,
      DireccionEntrega: this.configService.validaciones.DireccionEntrega,
      IdRegion: this.configService.validaciones.IdRegion,
      IdSucursal: this.configService.validaciones.IdSucursal,
      IdTerminoPago: this.configService.validaciones.IdTerminoPago,
      ListaPrecios: this.configService.validaciones.ListaPrecios,
      NroClienteDistribuidor: this.configService.validaciones.NroClienteDistribuidor,
      ZonaVendedor: this.configService.validaciones.ZonaVendedor,
      IdMoneda: this.configService.validaciones.IdMoneda,
      IdDivision: this.configService.validaciones.IdDivision,
      IdGrupoCliente: this.configService.validaciones.IdGrupoCliente,
      IdPlanta: this.configService.validaciones.IdPlanta,
      StorageLocation: this.configService.validaciones.StorageLocation,
      CantidadRequerida: this.configService.validaciones.CantidadRequerida,
      Email: this.configService.validaciones.Email,
      NroOC: this.configService.validaciones.NroOC,
      FechaEntrega: this.configService.validaciones.FechaEntrega,

    }
    this.Mensajes = {
      CreditoVencido: this.configService.mensajes.CreditoVencido,
      DescuentosNegativos: this.configService.mensajes.DescuentosNegativos,
    }
    this.Etiquetas = {

      Fecha: this.configService.etiquetas.Fecha,
      FechaEntrega: this.configService.etiquetas.FechaEntrega,
      StorageLocation: this.configService.etiquetas.StorageLocation,
      CantidadComprada: this.configService.etiquetas.CantidadComprada,
      Cantidad: this.configService.etiquetas.Cantidad,
      TotalFactura: this.configService.etiquetas.TotalFactura,
      FechaVencimiento: this.configService.etiquetas.FechaVencimiento,
      Acciones: this.configService.etiquetas.Acciones,
      Buscar: this.configService.etiquetas.Buscar,
      CantidadProgramada: this.configService.etiquetas.CantidadProgramada,
      CantidadRequerida: this.configService.etiquetas.CantidadRequerida,
      CantidadDisponible: this.configService.etiquetas.CantidadDisponible,
      CantidadDisponibleCuota: this.configService.etiquetas.CantidadDisponibleCuota,
      Cliente: this.configService.etiquetas.Cliente,
      Comentario: this.configService.etiquetas.Comentario,
      Planta: this.configService.etiquetas.PedidosEspecialesPlanta.PEP.Planta,
      Compania: this.configService.etiquetas.Compania,
      CalleNroDireccionEntrega: this.configService.etiquetas.CalleNroDireccionEntrega,
      CiudadDireccionEntrega: this.configService.etiquetas.CiudadDireccionEntrega,
      CPDireccionEntrega: this.configService.etiquetas.CPDireccionEntrega,
      NombreClienteDireccionEntrega: this.configService.etiquetas.NombreClienteDireccionEntrega,
      NroClienteDireccionEntrega: this.configService.etiquetas.NroClienteDireccionEntrega,
      ItemDistribuidor: this.configService.etiquetas.ItemDistribuidor,
      ItemPlanta: this.configService.etiquetas.ItemPlanta,
      CuentaDistribuidor: this.configService.etiquetas.CuentaDistribuidor,
      CuitCliente: this.configService.etiquetas.CuitCliente,
      DescripcionItemDescuento: this.configService.etiquetas.DescripcionItemDescuento,
      Descuento: this.configService.etiquetas.Descuento,
      DescuentoCategoria: this.configService.etiquetas.DescuentoCategoria,
      DescuentoDiscrecional: this.configService.etiquetas.DescuentoDiscrecional,
      Direccion: this.configService.etiquetas.PedidosVenta.PV.Direccion,
      DireccionEntrega: this.configService.etiquetas.DireccionEntrega,
      Division: this.configService.etiquetas.FilterDivision,
      Estado: this.configService.etiquetas.Estado,
      FechaCreacion: this.configService.etiquetas.FechaCreacion,
      FechaDesde: this.configService.etiquetas.FechaDesde,
      FechaEstado: this.configService.etiquetas.FechaEstado,
      FechaHasta: this.configService.etiquetas.FechaHasta,
      Glosa: this.configService.etiquetas.Glosa,
      IdLote: this.configService.etiquetas.Inventarios.IdLote,
      IdGrupoCliente: this.configService.etiquetas.IdGrupoCliente,
      IdMoneda: this.configService.etiquetas.IdMoneda,
      IdProducto: this.configService.etiquetas.IdProducto,
      IdTaxClassification: this.configService.etiquetas.IdTaxClassification,
      IdTipoCondicion: this.configService.etiquetas.IdTipoCondicion,
      IdTipoListaPrecios: this.configService.etiquetas.IdTipoListaPrecios,
      Importe: this.configService.etiquetas.Importe,
      Item: this.configService.etiquetas.Item,
      MensajeIntegracion: this.configService.etiquetas.MensajeIntegracion,
      MotivoRetencion: this.configService.etiquetas.MotivoRetencion,
      NombreCliente: this.configService.etiquetas.NombreCliente,
      NombreDistribuidor: this.configService.etiquetas.NombreDistribuidor,
      NroCliente: this.configService.etiquetas.NroCliente,
      NroFactura: this.configService.etiquetas.NroFactura,
      NroLinea: this.configService.etiquetas.NroLinea,
      NroOrdenSAP: this.configService.etiquetas.NroOrdenSAP,
      NroPedido: this.configService.etiquetas.NroPedido,
      NroCotizacion: this.configService.etiquetas.NroCotizacion,
      NroRemito: this.configService.etiquetas.NroRemito,
      Path: this.configService.etiquetas.PedidosVenta.PV.Path,
      Porcentaje: this.configService.etiquetas.Porcentaje,
      PrecioKGL: this.configService.etiquetas.PrecioKGL,
      PrecioUnitarioFinal: this.configService.etiquetas.PrecioUnitarioFinal,
      PrecioUnitarioLista: this.configService.etiquetas.PrecioUnitarioLista,
      Producto: this.configService.etiquetas.Producto,
      Recargo: this.configService.etiquetas.Recargo,
      Region: this.configService.etiquetas.Region,
      SalesOrg: this.configService.etiquetas.SalesOrg,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      TerminoPago: this.configService.etiquetas.TerminoPago,
      TipoEntrega: this.configService.etiquetas.TipoEntrega,
      TipoListaPrecios: this.configService.etiquetas.TipoListaPrecios,
      TipoOrden: this.configService.etiquetas.TipoOrden,
      Titulo: this.configService.etiquetas.Cotizaciones.Cotizacion.Titulo,
      Total: this.configService.etiquetas.Total,
      TotalDescuento: this.configService.etiquetas.TotalDescuento,
      TotalLocal: this.configService.etiquetas.TotalLocal,
      TotalPrecioKGL: this.configService.etiquetas.TotalPrecioKGL,
      ZonaVendedor: this.configService.etiquetas.ZonaVendedor,
      ZonaVendedorSeleccionada: this.configService.etiquetas.ZonaVendedorSeleccionada,
      Email: this.configService.etiquetas.Cotizaciones.Cotizacion.Email,
      SalesOffice: this.configService.etiquetas.IdSalesOffice,
      EmailOpcional: this.configService.etiquetas.Cotizaciones.Cotizacion.EmailOpcional,
      FechaPrecio: this.configService.etiquetas.FechaPrecio,
      Descuentos: this.configService.etiquetas.Descuentos,
      NroOC: this.configService.etiquetas.NroOC
    }

    const hoy = new Date();
    const fifteenDaysAgo = new Date();
    fifteenDaysAgo.setDate(hoy.getDate() - 14);
    this.minDate = fifteenDaysAgo;

    //#region Inicialización de autocompletables

    this.fcAutocompleteCliente.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermCliente
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.clientesEncontrados = [];
          this.loadingFcAutocompleteCliente = true;
        }),
        switchMap(value => this.admService.cClientesPedidoAutocompleteSearch(this.loggedService.logged.idPais, this.cabForm.controls['idCompania'].value, this.cabForm.controls['idSalesOrg'].value, this.loggedService.logged.idDivision, this.loggedService.logged.idZonaVendedor, this.loggedService.logged.idRegion, value)
          .pipe(
            finalize(() => {
              this.loadingFcAutocompleteCliente = false
            }),
          )
        )
      )
      .subscribe((data: Cuenta[]) => {
        this.clientesEncontrados = data;

      });

    this.fcAutocompleteZv.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermZV
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.zvsEncontradas = [];
          this.loadingFcAutocompleteZV = true;
        }),
        switchMap(value => this.admService.cZonasVendedoresAutocompleteSearch(this.loggedService.logged.idPais, this.cabForm.controls['idCompania'].value, this.cabForm.controls['idSalesOrg'].value, value)
          .pipe(
            finalize(() => {
              this.loadingFcAutocompleteZV = false
            }),
          )
        )
      )
      .subscribe((data: ZonaVendedor[]) => {
        this.zvsEncontradas = data;


      });


    this.fcAutocompleteLP.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermLP
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.lpsEncontradas = [];
          this.loadingFcAutocompleteLP = true;
        }),

        switchMap(value => this.cotizacionesService.cListasPreciosAutocompleteSearch(this.loggedService.logged.idPais, this.cabForm.controls['idCompania'].value,
          this.cabForm.controls['idSalesOrg'].value, this.cabForm.controls['nroCliente'].value, this.cabForm.controls['idTipoOrden'].value, value)
          .pipe(
            finalize(() => {
              this.loadingFcAutocompleteLP = false
            }),
          )
        )
      )
      .subscribe((data: ListaPrecioCabecera[]) => {

        //this.scrollToInvalidFormControls(this.cabForm);
        if (data != null) {
          this.lpsEncontradas = data;

        }

      });
    if (this.isInRole('VENDEDOR')) {
      // sacar required de idplanta en la cabecera y de idplanta y idubicacionalmacenamiento en el item
      this.cabForm.controls['idPlanta'].clearValidators();
      this.itemForm.controls['idPlanta'].clearValidators();
      this.itemForm.controls['idUbicacionAlmacenamiento'].clearValidators();

      this.cabForm.controls['idPlanta'].updateValueAndValidity();
      this.itemForm.controls['idPlanta'].updateValueAndValidity();
      this.itemForm.controls['idUbicacionAlmacenamiento'].updateValueAndValidity();

      this.fcAutocompleteItem.valueChanges
        .pipe(
          startWith(''),
          filter(res => {
            return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermItem
          }),
          distinctUntilChanged(),
          debounceTime(1000),
          tap(() => {

            this.itemsEncontrados = [];
            this.loadingFcAutocompleteItem = true;
          }),
          switchMap(value => {
            const idUbicacionAlmacenamiento = this.itemForm.controls['idUbicacionAlmacenamiento'].value;

            return this.cotizacionesService.cListaPrecioItemsAutocompleteSearch(
              this.loggedService.logged.idPais,
              this.cabForm.controls['idCompania'].value,
              this.cabForm.controls['idSalesOrg'].value,
              this.cabForm.controls['idTipoListaPrecios'].value,
              this.cabForm.controls['idTerminoPago'].value,
              this.cabForm.controls['idMoneda'].value,
              this.itemForm.controls['idPlanta'].value,
              idUbicacionAlmacenamiento,
              value
            ).pipe(
              finalize(() => {
                this.loadingFcAutocompleteItem = false
              })
            );
          })
        )
        .subscribe((data: ListaPrecioItem[]) => {
          this.scrollToInvalidFormControls(this.cabForm);
          if (data != null) {
            this.itemsEncontrados = data;

          }

        });
    } else {
      this.fcAutocompleteItem.valueChanges
        .pipe(
          startWith(''),
          filter(res => {
            return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermItem
          }),
          distinctUntilChanged(),
          debounceTime(1000),
          tap(() => {

            this.itemsEncontrados = [];
            this.loadingFcAutocompleteItem = true;
          }),
          switchMap(value => {
            const idUbicacionAlmacenamiento = this.itemForm.controls['idUbicacionAlmacenamiento'].value;
            this.itemForm.controls['idUbicacionAlmacenamiento'].markAsTouched();
            if (!idUbicacionAlmacenamiento) {
              this.loadingFcAutocompleteItem = false;
              return [];
            }
            return this.cotizacionesService.cListaPrecioItemsAutocompleteSearch(
              this.loggedService.logged.idPais,
              this.cabForm.controls['idCompania'].value,
              this.cabForm.controls['idSalesOrg'].value,
              this.cabForm.controls['idTipoListaPrecios'].value,
              this.cabForm.controls['idTerminoPago'].value,
              this.cabForm.controls['idMoneda'].value,
              this.itemForm.controls['idPlanta'].value,
              idUbicacionAlmacenamiento,
              value
            ).pipe(
              finalize(() => {
                this.loadingFcAutocompleteItem = false
              })
            );
          })
        )
        .subscribe((data: ListaPrecioItem[]) => {
          this.scrollToInvalidFormControls(this.cabForm);
          if (data != null) {
            this.itemsEncontrados = data;

          }

        });
    }

    //#endregion


    this.itemForm.get('cantDispDistribuidor').valueChanges.subscribe(() => {
      this.itemForm.controls['cantidadDistribuidor'].setValue(0);
      this.itemForm.controls['cantidadDistribuidor'].clearValidators();
      this.itemForm.controls['cantidadDistribuidor'].setValidators([Validators.max(this.itemForm.controls['cantDispDistribuidor'].value)]);
      this.itemForm.controls['cantidadDistribuidor'].updateValueAndValidity();
    })

    this.itemForm.get('cantidadDistribuidor').valueChanges.subscribe(() => {
      this.calcularCantidadComprada();
    })

    this.itemForm.get('cantDispDistribuidorPrimerCuota').valueChanges.subscribe(() => {
      this.itemForm.controls['cantDistribuidorPrimerCuota'].setValue(0);
      this.itemForm.controls['cantDistribuidorPrimerCuota'].clearValidators();
      this.itemForm.controls['cantDistribuidorPrimerCuota'].setValidators([Validators.max(this.itemForm.controls['cantDispDistribuidorPrimerCuota'].value)]);
      this.itemForm.controls['cantDistribuidorPrimerCuota'].updateValueAndValidity();
    })

    this.itemForm.get('cantDistribuidorPrimerCuota').valueChanges.subscribe(() => {
      this.calcularCantidadComprada();
    })

    this.itemForm.get('cantDispDistribuidorSegundaCuota').valueChanges.subscribe(() => {
      this.itemForm.controls['cantDistribuidorSegundaCuota'].setValue(0);
      this.itemForm.controls['cantDistribuidorSegundaCuota'].clearValidators();
      this.itemForm.controls['cantDistribuidorSegundaCuota'].setValidators([Validators.max(this.itemForm.controls['cantDispDistribuidorSegundaCuota'].value)]);
      this.itemForm.controls['cantDistribuidorSegundaCuota'].updateValueAndValidity();
    })

    this.itemForm.get('cantDistribuidorSegundaCuota').valueChanges.subscribe(() => {
      this.calcularCantidadComprada();
    })

    this.itemForm.get('cantDispDistribuidorTercerCuota').valueChanges.subscribe(() => {
      this.itemForm.controls['cantDistribuidorTercerCuota'].setValue(0);
      this.itemForm.controls['cantDistribuidorTercerCuota'].clearValidators();
      this.itemForm.controls['cantDistribuidorTercerCuota'].setValidators([Validators.max(this.itemForm.controls['cantDispDistribuidorTercerCuota'].value)]);
      this.itemForm.controls['cantDistribuidorTercerCuota'].updateValueAndValidity();
    })

    this.itemForm.get('cantDistribuidorTercerCuota').valueChanges.subscribe(() => {
      this.calcularCantidadComprada();
    })

    this.itemForm.get('cantidadPlanta').valueChanges.subscribe(() => {
      this.calcularCantidadComprada();
    })

    this.itemForm.get('cantDispPlantaPrimerCuota').valueChanges.subscribe(() => {
      this.itemForm.controls['cantPlantaPrimerCuota'].setValue(0);
      this.itemForm.controls['cantPlantaPrimerCuota'].clearValidators();
      this.itemForm.controls['cantPlantaPrimerCuota'].setValidators([Validators.max(this.itemForm.controls['cantDispPlantaPrimerCuota'].value)]);
      this.itemForm.controls['cantPlantaPrimerCuota'].updateValueAndValidity();
    })

    this.itemForm.get('cantPlantaPrimerCuota').valueChanges.subscribe(() => {
      this.calcularCantidadComprada();
    })

    this.itemForm.get('cantDispPlantaSegundaCuota').valueChanges.subscribe(() => {
      this.itemForm.controls['cantPlantaSegundaCuota'].setValue(0);
      this.itemForm.controls['cantPlantaSegundaCuota'].clearValidators();
      this.itemForm.controls['cantPlantaSegundaCuota'].setValidators([Validators.max(this.itemForm.controls['cantDispPlantaSegundaCuota'].value)]);
      this.itemForm.controls['cantPlantaSegundaCuota'].updateValueAndValidity();
    })

    this.itemForm.get('cantPlantaSegundaCuota').valueChanges.subscribe(() => {
      this.calcularCantidadComprada();
    })

    this.itemForm.get('cantDispPlantaTercerCuota').valueChanges.subscribe(() => {
      this.itemForm.controls['cantPlantaTercerCuota'].setValue(0);
      this.itemForm.controls['cantPlantaTercerCuota'].clearValidators();
      this.itemForm.controls['cantPlantaTercerCuota'].setValidators([Validators.max(this.itemForm.controls['cantDispPlantaTercerCuota'].value)]);
      this.itemForm.controls['cantPlantaTercerCuota'].updateValueAndValidity();
    })

    this.itemForm.get('cantPlantaTercerCuota').valueChanges.subscribe(() => {
      this.calcularCantidadComprada();
    })



    this.cotizacionesService
      .cCotizacion(this.codigoEdit)
      .subscribe((cab: CotizacionCabecera) => {

        if (cab != null) {
          forkJoin([
            this.admService.cCompanias(this.loggedService.logged.idPais),
            this.admService.cSalesOrgs(this.loggedService.logged.idPais, this.loggedService.logged.idCompania),
            this.admService.cDivisiones(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg, this.loggedService.logged.userName),
            this.parametrosService.cItemsParametros(10),
            this.parametrosService.cItemParametroXDescripcionItem(25, "Cotizacion"), //Cambiar descripcionItem segun tipo de pedido
            this.tablasService.cMonedas(this.loggedService.logged.idPais),
            this.parametrosService.cItemsParametros(60), //Permisos Alta
            this.tablasService.cPlantas(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg),
            this.parametrosService.cItemsParametros(16), //Dias habiles de la cotizacion
            this.parametrosService.cItemsParametros(69) //Disclaimer Cotizaciones
          ]).subscribe((data: [Compania[], SalesOrg[], Division[], ItemParametro[], ItemParametro, Moneda[], ItemParametro[], Deposito[], ItemParametro, ItemParametro[]]) => {

            if (this.idTipo == 1) {
              if (data[6] != null) {
                if (data[6].length) {
                  if (this.loggedService.validToken()) {
                    data[6].forEach(rol => {
                      if (this.loggedService.logged.rol == rol.idItem && !this.alta) {
                        this.alta = true;
                      }
                    });
                  }
                }
              }
            }
            if (!this.alta && this.idTipo == 1) {
              this.volver();
            }

            if (data[0].length) {

              this.companias = data[0];
              if (this.codigoEdit == 0) {
                this.companiaSeleccionada = data[0][0];
              }

            }

            if (data[1].length) {
              this.salesOrgs = data[1];
              if (this.codigoEdit == 0) {
                this.salesOrgSeleccionada = data[1][0];
              }
            }

            if (data[2].length) {
              this.divisiones = data[2];
            }

            if (data[3].length) {
              this.motivosRetencion = data[3];
            }

            if (data[5].length) {
              this.monedas = data[5];
            }

            if (data[7].length) {
              this.plantas = data[7];
              this.plantasItem = data[7];
            }

            if (data[8] != null)//dias habiles cot
            {
              this.diasCotizacionRechazada = data[8];
            }

            if (data[9].length) {
              this.disclaimersCotizaciones = data[9];
            }
            if (this.idTipo == 2 || this.idTipo == 3) {
              if (cab.usuarioRedSolicitante == this.loggedService.logged.userName || this.isInRole('ADMVENTAS') || this.isInRole('ADM LOCAL') || this.isInRole('ADM')) {
                this.alta = true
              }
            }
            loadData(this.cabForm, cab)
            this.cabForm.controls['tipoCambio'].setValue(cab.tipoCambio == null ? 0 : cab.tipoCambio);

            this.cabForm.controls['idPais'].setValue(this.loggedService.logged.idPais);

            if (this.codigoEdit == 0) {
              this.cabForm.controls['idCompania'].setValue(this.companias[0].id);
              this.cabForm.controls['compania'].setValue(this.companias[0].descripcion);
              this.cabForm.controls['idSalesOrg'].setValue(this.salesOrgs[0].id);
              this.cabForm.controls['salesOrg'].setValue(this.salesOrgs[0].descripcion);
              this.cabForm.controls['idDivision'].setValue(this.divisiones[0].id);
              this.seleccionarDivision(this.cabForm.controls['idDivision'].value);
              this.cabForm.controls['idMoneda'].setValue(this.monedas[0].id);
              this.seleccionarMoneda(this.cabForm.controls['idMoneda'].value);
              this.codigoEdit = cab.codigo;
            }
            else {
              if (cab.idEstado == 1) {
                this.admService
                  .cMensajesCliente(cab.idPais, cab.idCompania, cab.idSalesOrg, cab.nroCliente)
                  .subscribe((datac: DataClientePedidos) => {

                    if (datac != null) {

                      this.mensajeDeudaVencida = datac.mensajeDeudaVencida;
                      this.mensajeCreditoExcedido = datac.mensajeCreditoExcedido;
                      this.credito = datac.credito;
                    }

                  })

              }


              this.companiaSeleccionada = new Compania();
              this.companiaSeleccionada.id = cab.idCompania;
              this.companiaSeleccionada.descripcion = cab.compania;


              this.salesOrgSeleccionada = new SalesOrg();
              this.salesOrgSeleccionada.id = cab.idSalesOrg;
              this.salesOrgSeleccionada.descripcion = cab.salesOrg;
              this.cabForm.controls['fechaEntrega'].setValue(cab.fechaEntrega);
              this.divisionSeleccionada = new Division();
              this.divisionSeleccionada.displayValue = cab.division + ' - ' + cab.idDivision;
              this.cabForm.controls['idDivision'].setValue(cab.idDivision);
              this.cabForm.controls['division'].setValue(cab.division);
              this.zvSeleccionada = new ZonaVendedor();
              this.zvSeleccionada.displayValue = cab.idZonaVendedor + ' - ' + cab.nombreVendedor;
              this.ctaDistrubuidorSeleccionada = new CuentaDistribuidor();
              this.ctaDistrubuidorSeleccionada.nombre = cab.nombreDistribuidor;
              this.dirEntregaSeleccionada = new Direccion();
              this.dirEntregaSeleccionada.nroCliente = cab.nroClienteDireccionEntrega

              this.direccionSeleccionada = new Cuenta();
              this.direccionSeleccionada.displayValue2 = cab.sucursal;

              this.regionSeleccionada = new Region();
              this.regionSeleccionada.displayValue = cab.idRegion + ' - ' + cab.region;

              this.gcSeleccionado = new GrupoCliente();
              this.gcSeleccionado.id = cab.idGrupoCliente;
              this.gcSeleccionado.descripcion = cab.grupoCliente;
              this.gcSeleccionado.displayValue = cab.idGrupoCliente + ' - ' + cab.grupoCliente;

              this.tpSeleccionado = new TerminoPago();
              this.tpSeleccionado.id = cab.idTerminoPago;
              this.tpSeleccionado.descripcion = cab.terminoPago;
              this.tpSeleccionado.displayValue = cab.terminoPago;


              this.monedaSeleccionada = new Moneda();
              this.monedaSeleccionada.id = cab.idMoneda;
              this.monedaSeleccionada.descripcion = cab.moneda;

              this.cabForm.controls['idPlanta'].setValue(cab.idPlanta);
              this.itemForm.controls['idPlanta'].setValue(cab.idPlanta);
              if (cab.idPlanta) {

                this.plantaSeleccionada = new Deposito();
                this.plantaSeleccionada.displayValue = cab.idPlanta + ' - ' + cab.planta;
                this.seleccionarPlantaItem(cab.idPlanta); //  en el item pone la planta de la cabecera y carga storagelocations correspondientes
              }

              this.dataSourceItems.data = (cab.items != null) && cab.items.length ? cab.items : [];

              console.log(this.dataSourceItems.data)
              this.dataSourceItemsDescuentos.data = (cab.itemsDescuento != null) && cab.itemsDescuento.length ? cab.itemsDescuento : [];
              if (this.dataSourceItems.data.length) {
                this.totalItems = this.dataSourceItems.data.map(a => a.total).reduce(function (a, b) {
                  return a + b;
                });
                this.cDescuentosDiscrecionalesNegativos();
              }
        this.cotizacionesService.cCotizacionRetenciones(cab.idPais, cab.idCompania, cab.idSalesOrg, cab.nroPedido)
          .subscribe((data: CotizacionRetencion[]) => {
            this.retenciones = data;
          });

              // if (!this.dataSourceItems.data.length) {//se guardo la cabecera pero no hay items
              if (cab.idEstado == 1) {

                this.clienteSeleccionado = new Cuenta();
                this.clienteSeleccionado.idPais = cab.idPais
                this.clienteSeleccionado.idSalesOrg = cab.idSalesOrg
                this.clienteSeleccionado.idCompania = cab.idCompania
                this.clienteSeleccionado.nroCliente = cab.nroCliente
                this.clienteSeleccionado.idCondicionPago = cab.idTerminoPago


                this.admService
                  .cDataClienteSeleccionado(cab.idPais, cab.idCompania, cab.idSalesOrg, cab.idDivision, cab.nroCliente)
                  .subscribe((datac: DataClientePedidos) => {

                    if (datac != null) {

                      this.avisoCreditoVencido = datac.cuenta != null ? datac.cuenta.creditoVencido : false;
                      this.dirEntregas = datac.direccionesEntregas != null ? datac.direccionesEntregas : []
                      //this.avisoCreditoVencido = this.idTipo == 2 || this.idTipo == 3 ? false : this.avisoCreditoVencido;
                      this.regiones = datac.regiones != null ? datac.regiones : [];
                      //this.direcciones = datac.direcciones != null ? datac.direcciones : [];
                      this.gcs = datac.gruposCliente != null ? datac.gruposCliente : [];
                      if (this.gcs.length) {
                        if (cab.idGrupoCliente != null) {
                          this.cabForm.controls['idGrupoCliente'].setValue(cab.idGrupoCliente);
                        }
                        else {
                          this.cabForm.controls['idGrupoCliente'].setValue(datac.grupoCliente != null ? datac.grupoCliente.id : '');
                        }
                        this.seleccionarGC(this.cabForm.controls['idGrupoCliente'].value)
                      }
                      this.cuentasDistribuidores = datac.cuentasDistribuidores != null ? datac.cuentasDistribuidores : [];
                      if (this.cuentasDistribuidores.length) {
                        if (cab.nroClienteDistribuidor != null) {
                          this.cabForm.controls['nroClienteDistribuidor'].setValue(cab.nroClienteDistribuidor);
                        }

                        this.seleccionarCuentaDistribuidor(this.cabForm.controls['nroClienteDistribuidor'].value, cab.idSucursal);

                      }
                      else {
                        this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ClienteSinDisrtribuidores, 2, 2);
                      }

                      if (cab.nroClienteDireccionEntrega != null) {
                        this.dirEntregaSeleccionada = new Direccion();
                        this.dirEntregaSeleccionada.calleNro = cab.calleNroDireccionEntrega
                        this.dirEntregaSeleccionada.ciudad = cab.ciudadDireccionEntrega
                        this.dirEntregaSeleccionada.codigoPostal = cab.cPDireccionEntrega
                        this.dirEntregaSeleccionada.nombre = cab.nombreClienteDireccionEntrega
                        this.dirEntregaSeleccionada.nroCliente = cab.nroClienteDireccionEntrega
                        this.seleccionarDirEntrega(this.dirEntregaSeleccionada, cab.idSucursal != null ? cab.idSucursal : null)
                      }

                      if (cab.idRegion != null) {
                        this.cabForm.controls['idRegion'].setValue(cab.idRegion);
                      }
                      else {
                        if (datac.zonaVendedor?.idRegion?.length) {
                          this.cabForm.controls['idRegion'].setValue(datac.zonaVendedor.idRegion);
                        }
                        else {
                          this.cabForm.controls['idRegion'].setValue(this.regiones != null && this.regiones.length ? this.regiones[0].id : '');
                        }
                      }
                      if (this.cabForm.controls['idRegion'].valid) {
                        this.seleccionarRegion(this.cabForm.controls['idRegion'].value);
                      }

                      this.zvSeleccionada = cab.zonaVendedor != null ? cab.zonaVendedor : (datac.zonaVendedor != null ? datac.zonaVendedor : null);

                      this.cabForm.controls['idZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.id : '');
                      this.cabForm.controls['usuarioRedZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.usuarioVendedor : '');
                      this.cabForm.controls['nombreVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.descripcion : '');

                    }

                  })



              }
              // else
              // {
              //   this.cabForm.get('fechaEntrega').disable();
              // }

              if (cab.listaPreciosCabecera != null) {
                this.seleccionarLP(cab.listaPreciosCabecera, cab.idTerminoPago != null ? cab.idTerminoPago : null)
              }

            }


            let timer = setTimeout(() => {

              this.cabForm.get('idDivision').valueChanges.subscribe(() => { this.limpiarCliente(true); })

              loadData(this.itemForm, this.cabForm.value);
              this.cabForm.controls['items'].reset();

            }, 2000);

          });
        }

      })
    console.log("displayedColumnsItems:", this.displayedColumnsItems);

    /* this.cabForm.get('nroClienteDireccionEntrega').valueChanges.subscribe(() => {
      if(this.cabForm.get('nroClienteDistribuidor').value == '3122124' 
      && this.cabForm.get('idEstado').value == '1')
      {
        this.calcularFechaEntrega();
      }
    }); */

  }


  calcularFechaEntrega() {
    this.cotizacionesService
      .obtenerFechaEntrega(this.cabForm.controls['nroClienteDireccionEntrega'].value)
      .subscribe((fecha: Date) => {
        this.cabForm.controls['fechaEntrega'].setValue(fecha);

      });
  }
  guardar() {
    // console.log(this.cabForm);
    if (this.cabForm.valid) {

      this.cabForm.controls['items'].setValue([]);
      this.cabForm.controls['itemsDescuento'].setValue([]);

      this.cotizacionesService
        .amCotizacion(this.cabForm.value)
        .subscribe((data: CotizacionCabecera) => {
          if (data != null) {

            this.limpiarItem(true);
            if (this.codigoEdit == 0) {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 2);
            }
            else {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 2);
            }
            this.codigoEdit = data.codigo;
            this.cabForm.controls['codigo'].setValue(this.codigoEdit);
            this.cabForm.controls['nroPedido'].setValue(data.nroPedido);

            this.idTipo == 2
          }

        })
    }
    else {
      this.scrollToInvalidFormControls(this.cabForm);
    }


  }


  seleccionarDivision(d: any) {

    this.divisionSeleccionada = null;
    if (d != null) {
      this.divisionSeleccionada = this.divisiones.find(c => c.id == this.cabForm.controls['idDivision'].value);
      if (this.divisionSeleccionada != null) {
        this.cabForm.controls['division'].setValue(this.divisionSeleccionada.descripcion);
      }
    }
    else {
      this.cabForm.controls['division'].reset();
    }

  }
  updateDateRangePrimerCuota(date: string) {
    const [monthStr, yearStr] = date.split('-');
    const month = parseInt(monthStr, 10) - 1; // restamos 1 porque los meses en JS van de 0 a 11
    const year = parseInt(yearStr, 10);

    this.minDateFechaEntregaPrimerCuota = new Date(year, month, 1);

  }
  updateDateRangeSegundaCuota(date: string) {
    const [monthStr, yearStr] = date.split('-');
    const month = parseInt(monthStr, 10) - 1; // restamos 1 porque los meses en JS van de 0 a 11
    const year = parseInt(yearStr, 10);

    this.minDateFechaEntregaSegundaCuota = new Date(year, month, 1);

  }
  updateDateRangeTercerCuota(date: string) {
    const [monthStr, yearStr] = date.split('-');
    const month = parseInt(monthStr, 10) - 1; // restamos 1 porque los meses en JS van de 0 a 11
    const year = parseInt(yearStr, 10);

    this.minDateFechaEntregaTercerCuota = new Date(year, month, 1);

  }
  seleccionarCliente(c: any, idGrupoCliente: string, nroClienteDistribuidor: string, idSucursal: string, idRegion: string, zonaVendedor: ZonaVendedor) {

    if (c != "-1") {
      this.clienteSeleccionado = c; //El autocomplete trae el objeto para asignar a la variable. El autocomplete NO esta enlazado con esta variable
      this.fcAutocompleteZv.reset();
      this.admService
        .cDataClienteSeleccionado(this.clienteSeleccionado.idPais, this.clienteSeleccionado.idCompania, this.clienteSeleccionado.idSalesOrg, this.cabForm.controls['idDivision'].value, this.clienteSeleccionado.nroCliente)
        .subscribe((data: DataClientePedidos) => {

          this.cabForm.controls['cuit'].setValue(this.clienteSeleccionado.cuit);
          this.cabForm.controls['nroCliente'].setValue(this.clienteSeleccionado.nroCliente);
          this.cabForm.controls['nombreCliente'].setValue(this.clienteSeleccionado.nombre);
          this.cabForm.controls['email'].setValue(this.clienteSeleccionado.email);
          this.cabForm.controls['emailOpcional'].setValue(this.clienteSeleccionado.emailOpcional);
          this.cabForm.controls['idSalesOffice'].setValue(this.clienteSeleccionado.idSalesOffice);

          if (data != null) {
            this.mensajeDeudaVencida = data.mensajeDeudaVencida;
            this.mensajeCreditoExcedido = data.mensajeCreditoExcedido;
            this.credito = data.credito;
            this.avisoCreditoVencido = data.cuenta != null ? data.cuenta.creditoVencido : false;
            this.regiones = data.regiones != null ? data.regiones : [];
            this.dirEntregas = data.direccionesEntregas != null ? data.direccionesEntregas : []

            this.gcs = data.gruposCliente != null ? data.gruposCliente : [];
            if (this.gcs.length) {
              if (this.clienteSeleccionado.idTipoCliente != null) {
                this.cabForm.controls['idGrupoCliente'].setValue(this.clienteSeleccionado.idTipoCliente);
              }
              else {
                this.cabForm.controls['idGrupoCliente'].setValue(data.grupoCliente != null ? data.grupoCliente.id : '');
              }
              this.seleccionarGC(this.cabForm.controls['idGrupoCliente'].value)
            }
            this.cuentasDistribuidores = data.cuentasDistribuidores != null ? data.cuentasDistribuidores : [];
            if (this.cuentasDistribuidores.length) {
              if (nroClienteDistribuidor != null) {
                this.cabForm.controls['nroClienteDistribuidor'].setValue(nroClienteDistribuidor);
              }
              else {
                if (this.cabForm.controls['idEstado'].value == 1) {
                  this.cabForm.controls['nroClienteDistribuidor'].setValue(data.cuentasDistribuidores[0].nroClienteDistribuidor);
                }
              }
              this.seleccionarCuentaDistribuidor(this.cabForm.controls['nroClienteDistribuidor'].value, idSucursal);

            }
            else {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ClienteSinDisrtribuidores, 2, 2);
            }

            if (idRegion != null) {
              this.cabForm.controls['idRegion'].setValue(idRegion);
            }
            else {
              if (data.zonaVendedor?.idRegion?.length) {
                this.cabForm.controls['idRegion'].setValue(data.zonaVendedor.idRegion);
              }
              else {
                this.cabForm.controls['idRegion'].setValue(this.regiones != null && this.regiones.length ? this.regiones[0].id : '');
              }
            }
            if (this.cabForm.controls['idRegion'].valid) {
              this.seleccionarRegion(this.cabForm.controls['idRegion'].value);
            }

            this.zvSeleccionada = zonaVendedor != null ? zonaVendedor : (data.zonaVendedor != null ? data.zonaVendedor : null);
            this.cabForm.controls['idZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.id : '');
            this.cabForm.controls['usuarioRedZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.usuarioVendedor : '');
            this.cabForm.controls['nombreVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.descripcion : '');

            this.cotizacionesService.cListasPreciosAutocompleteSearch(this.loggedService.logged.idPais, this.cabForm.controls['idCompania'].value,
              this.cabForm.controls['idSalesOrg'].value, this.cabForm.controls['nroCliente'].value, this.cabForm.controls['idTipoOrden'].value, '')
              .subscribe((data: ListaPrecioCabecera[]) => {
                this.lps = data
                const listaPorDefecto = data.find(lp => lp.defecto === true);

                if (listaPorDefecto) {
                  this.cabForm.controls['idTipoListaPrecios'].setValue(listaPorDefecto.id);
                  this.seleccionarLP(listaPorDefecto, null)
                } else if (data.length > 0) {

                  this.cabForm.controls['idTipoListaPrecios'].setValue(data[0].id);
                  this.seleccionarLP(data[0], null)
                }


              })


          }

        })

    }
    else {
      this.cabForm.controls['idRegion'].reset();
      this.cabForm.controls['idGrupoCliente'].reset();
      this.cabForm.controls['cuit'].reset();
      this.cabForm.controls['email'].reset();
      this.cabForm.controls['emailOpcional'].reset()
      this.cabForm.controls['nroCliente'].reset();
      this.cabForm.controls['nombreCliente'].reset();
      this.cabForm.controls['idSalesOffice'].reset();
      this.clienteSeleccionado = null;
    }

  }

  getOptionTextCliente(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  handleEmptyInputCliente(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTermCliente) {
      this.clientesEncontrados = [];
      this.clienteSeleccionado = null;

    }
  }

  limpiarCliente(resetFormControl: boolean) {
    this.clientesEncontrados = [];
    this.avisoCreditoVencido = false;
    this.mensajeCreditoExcedido = "";
    this.credito = null;
    this.mensajeDeudaVencida = "";
    this.limpiarVendedor(true);

    this.limpiarLP(true);
    this.seleccionarCuentaDistribuidor(null, null);
    this.seleccionarCliente("-1", null, null, null, null, null);
    this.seleccionarDirEntrega(null, null);
    this.cuentasDistribuidores = [];
    this.gcs = [];
    this.regiones = [];
    if (resetFormControl) {
      this.fcAutocompleteCliente.setValue('');

    }
    this.cabForm.markAsUntouched();
    this.cabForm.markAsPristine();

  }

  seleccionarGC(g: any) {

    this.gcSeleccionado = null;
    if (g != null) {
      this.gcSeleccionado = this.gcs.find(c => c.id == this.cabForm.controls['idGrupoCliente'].value);
      if (this.gcSeleccionado != null) {
        this.cabForm.controls['grupoCliente'].setValue(this.gcSeleccionado.descripcion);
      }
    }
    else {
      this.cabForm.controls['grupoCliente'].reset();
    }
  }

  seleccionarZonaVendedor(zv: any) {
    this.zvSeleccionada = zv;
    this.cabForm.controls['idZonaVendedor'].setValue(this.zvSeleccionada.id);
    this.cabForm.controls['usuarioRedZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.usuarioVendedor : '');
    this.cabForm.controls['nombreVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.descripcion : '');
    if (this.regiones.length) {

      this.cabForm.controls['idRegion'].setValue(this.zvSeleccionada.idRegion);
    }
  }

  handleEmptyInputVendedor(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTermZV) {
      this.limpiarVendedor(false);
    }
  }
  limpiarVendedor(resetFormControl: boolean) {
    this.zvsEncontradas = [];
    this.zvSeleccionada = null;
    this.cabForm.controls['idZonaVendedor'].reset();
    this.cabForm.controls['idRegion'].reset();
    this.cabForm.controls['usuarioRedZonaVendedor'].reset();
    this.cabForm.controls['nombreVendedor'].reset();
    if (resetFormControl) {
      this.fcAutocompleteZv.setValue('');
    }

  }

  getOptionTextZV(option) {
    if (option != null) {
      return option.displayValue;
    }
  }


  seleccionarRegion(r: any) {

    this.regionSeleccionada = null;
    if (r != null) {
      this.regionSeleccionada = this.regiones.find(c => c.id == this.cabForm.controls['idRegion'].value);
      if (this.regionSeleccionada != null) {
        this.cabForm.controls['region'].setValue(this.regionSeleccionada.descripcion);
      }
    }
    else {
      this.cabForm.controls['region'].reset();
    }

  }

  cambioEmail(e: any) {
    if (e.target.value !== null) {
      this.admService.actualizarEmail(this.cabForm.value).subscribe((data: string) => {

      });
    }
  }
  cambioEmailOpcional(e: any) {
    if (e.target.value !== null) {
      this.admService.actualizarEmailOpcional(this.cabForm.value).subscribe((data: string) => {

      });
    }
  }
  seleccionarCuentaDistribuidor(d: any, idSucursal: string) {
    this.seleccionarDireccion(null);
    this.direcciones = [];
    this.ctaDistrubuidorSeleccionada = null;
    if (d != null) {
      this.ctaDistrubuidorSeleccionada = this.cuentasDistribuidores.length == 1 ? this.cuentasDistribuidores[0] : this.cuentasDistribuidores.find(c => c.nroClienteDistribuidor == d)
      if (this.ctaDistrubuidorSeleccionada != null) {
        this.cabForm.controls['nombreDistribuidor'].setValue(this.ctaDistrubuidorSeleccionada.nombre);
      }
    }
    else {
      this.cabForm.controls['nombreDistribuidor'].reset();
    }
  }


  seleccionarDireccion(d: any) { //Sucursal

    this.direccionSeleccionada = null;
    if (d != null) {
      this.direccionSeleccionada = this.direcciones.find(c => c.nroCliente == this.cabForm.controls['idSucursal'].value);
      if (this.direccionSeleccionada != null) {
        this.cabForm.controls['sucursal'].setValue(this.direccionSeleccionada.ciudad + " - " + this.direccionSeleccionada.calleNro);
      }
    }
    else {
      this.cabForm.controls['sucursal'].reset();
    }

  }

  seleccionarMoneda(m: any) {

    this.monedaSeleccionada = null;
    if (m != null) {
      this.monedaSeleccionada = this.monedas.find(c => c.id == this.cabForm.controls['idMoneda'].value);
      if (this.monedaSeleccionada != null) {
        this.cabForm.controls['moneda'].setValue(this.monedaSeleccionada.descripcion);
      }
    }
    else {
      this.cabForm.controls['moneda'].reset();
    }

  }

  seleccionarLP(lp: any, idTerminoPago: string) {
    this.seleccionarTP(null);
    this.terminosPago = [];
    if (lp != "-1") {
      this.lpSeleccionada = lp;
      this.cabForm.controls['idTipoListaPrecios'].setValue(this.lpSeleccionada.id);
      this.cabForm.controls['tipoListaPrecios'].setValue(this.lpSeleccionada.descripcion);
      this.cabForm.controls['preciosFijos'].setValue(this.lpSeleccionada.precioFijo);

      this.cotizacionesService
        .cTerminosPagoTipoListaPrecios(this.lpSeleccionada.idPais, this.lpSeleccionada.idCompania, this.lpSeleccionada.idSalesOrg, this.lpSeleccionada.id)
        .subscribe((data: TerminoPago[]) => {

          if (data != null) {
            this.terminosPago = data.sort((a, b) => a.diasVencer - b.diasVencer);
            let tpAux: TerminoPago = null;
            if (idTerminoPago != null) {
              tpAux = this.terminosPago.find(c => c.id == idTerminoPago);
            }
            else {

              tpAux = this.terminosPago.find(c => c.id == this.clienteSeleccionado.idCondicionPago);
              if (!tpAux) this.cabForm.controls['idTerminoPago'].setValue(null);
            }
            if (tpAux != null) {
              this.cabForm.controls['idTerminoPago'].setValue(tpAux.id);
              this.seleccionarTP(this.cabForm.controls['idTerminoPago'].value)

            }
            let item: CotizacionItem = new CotizacionItem(this.cabForm.value);
            item.cantidad = 0;
            //loadData(this.itemForm, pvi);

          }

        })

    }
    else {
      this.cabForm.controls['idTipoListaPrecios'].reset();
      this.cabForm.controls['tipoListaPrecios'].reset();

      this.lpSeleccionada = null;
    }
  }

  limpiarLP(resetFormControl: boolean) {
    this.lpsEncontradas = [];
    this.seleccionarLP("-1", null);
    if (resetFormControl) {
      this.fcAutocompleteLP.setValue('');
    }

  }


  getOptionTextLP(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  handleEmptyInputLP(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTermLP) {
      this.lpsEncontradas = [];
      this.lpSeleccionada = null;
    }
  }

  seleccionarTP(tp: any) {

    this.tpSeleccionado = null;
    if (tp != null) {
      this.tpSeleccionado = this.terminosPago.find(c => c.id == tp);

      if (this.tpSeleccionado != null) {
        this.cabForm.controls['terminoPago'].setValue(this.tpSeleccionado.descripcion);
      }

    }
    else {
      this.cabForm.controls['terminoPago'].reset();

    }

  }

  seleccionarPlanta(p: any) {

    this.plantaSeleccionada = null;
    this.seleccionarPlantaItem(this.cabForm.controls['idPlanta'].value);
    if (p != null) {
      this.plantaSeleccionada = this.plantas.find(c => c.idPlanta == p);
      if (this.plantaSeleccionada != null) {
        this.cabForm.controls['planta'].setValue(this.plantaSeleccionada.descripcion);


        let i: CotizacionItem = new CotizacionItem(this.cabForm.value);
        i.cantidad = 0;
        loadData(this.itemForm, i);
        this.cabForm.markAllAsTouched();
      }
    }
    else {
      this.cabForm.controls['planta'].reset();

    }

  }
  getOptionTextItem(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  handleEmptyInputItem(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTermItem) {
      this.itemsEncontrados = [];
      this.itemSeleccionado = null;
    }
  }

  limpiarItem(resetFormControl: boolean) {
    this.itemsEncontrados = [];
    this.itemForm.controls['cantDispDistribuidor'].setValue(0);
    this.itemForm.controls['cantDispDistribuidorPrimerCuota'].setValue(0);
    this.itemForm.controls['cantDispDistribuidorSegundaCuota'].setValue(0);
    this.itemForm.controls['cantDispDistribuidorTercerCuota'].setValue(0);
    this.itemForm.controls['cantDispPlantaPrimerCuota'].setValue(0);
    this.itemForm.controls['cantDispPlantaSegundaCuota'].setValue(0);
    this.itemForm.controls['cantDispPlantaTercerCuota'].setValue(0);
    this.minDateFechaEntregaPrimerCuota = null;
    this.minDateFechaEntregaSegundaCuota = null;
    this.minDateFechaEntregaTercerCuota = null;
    this.itemForm.controls['fechaPrimerCuotaDistribuidor'].setValue(null);
    this.itemForm.controls['fechaSegundaCuotaDistribuidor'].setValue(null);
    this.itemForm.controls['fechaTercerCuotaDistribuidor'].setValue(null);

    this.itemForm.controls['cantidadDistribuidor'].setValue(0);
    this.itemForm.controls['cantidadPlanta'].setValue(0);
    this.itemForm.controls['cantidadComprada'].setValue(null);
    this.itemForm.controls['cantidadComprada'].clearValidators();
    this.itemForm.controls['cantidadComprada'].updateValueAndValidity();
    //this.itemForm.controls['cantidadRequerida'].setValue(0);
    this.avisoUnidadesPallet = false;
    this.avisoUnidadesPalletDistribuidor = false;
    this.avisoUnidadesPalletDistribuidorPrimerCuota = false;
    this.avisoUnidadesPalletDistribuidorSegundaCuota = false;
    this.avisoUnidadesPalletDistribuidorTercerCuota = false;
    this.avisoUnidadesPalletPlanta = false;
    this.avisoUnidadesPalletPlantaPrimerCuota = false;
    this.avisoUnidadesPalletPlantaSegundaCuota = false;
    this.avisoUnidadesPalletPlantaTercerCuota = false;

    this.seleccionarItem("-1");
    if (resetFormControl) {
      this.fcAutocompleteItem.setValue('');
    }
    this.itemForm.markAsUntouched();
    this.itemForm.markAsPristine();

  }
  seleccionarItem(i: any) {

    //this.itemForm.controls['cantidadRequerida'].setValue(0);
    if (i != "-1") {
      this.itemSeleccionado = i;

      if (this.isInRole('VENDEDOR')) { // el vendedor no puede seleccionar planta aplica la del item
        this.itemForm.controls['idPlanta'].setValue(this.itemSeleccionado.idPlanta);
      }

      this.itemForm.controls['idProducto'].setValue(this.itemSeleccionado.idProducto);
      this.itemForm.controls['producto'].setValue(this.itemSeleccionado.producto);
      this.itemForm.controls['precioUnitarioLista'].setValue(this.itemSeleccionado.tasa);
      this.cotizacionesService
        .cStockDisponible(this.loggedService.logged.idPais, this.cabForm.controls['idCompania'].value, this.cabForm.controls['idSalesOrg'].value, this.cabForm.controls['idDivision'].value,
          this.itemForm.controls['idPlanta'].value, this.itemForm.controls['idUbicacionAlmacenamiento'].value, this.cabForm.controls['idRegion'].value, this.cabForm.controls['nroClienteDistribuidor'].value, this.cabForm.controls['idSucursal'].value,
          this.itemForm.controls['idProducto'].value)
        .subscribe((data: Stock[]) => {

          const meses = [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
          ];
          if (data != null) {
            if (data.length) {
              this.itemForm.controls['cantDispDistribuidor'].setValue(data[0].cantidadDisponibleVenta);
              //Siempre habrá 3 cuotas de planta y 3 de distribuidor
              if (data[0].cuotasPlanta.length) {
                this.mesAnioPrimerCuotaPlanta = data[0].cuotasPlanta[0] != null ? data[0].cuotasPlanta[0].mes + "/" + data[0].cuotasPlanta[0].anio : "";
                this.mesAnioSegundaCuotaPlanta = data[0].cuotasPlanta[1] != null ? data[0].cuotasPlanta[1].mes + "/" + data[0].cuotasPlanta[1].anio : "";
                this.mesAnioTercerCuotaPlanta = data[0].cuotasPlanta[2] != null ? data[0].cuotasPlanta[2].mes + "/" + data[0].cuotasPlanta[2].anio : "";
                this.itemForm.controls['cantDispPlantaPrimerCuota'].setValue(data[0]?.cuotasPlanta[0]?.cantidadDisponibleVenta ?? 0);
                this.itemForm.controls['cantDispPlantaSegundaCuota'].setValue(data[0]?.cuotasPlanta[1]?.cantidadDisponibleVenta ?? 0);
                this.itemForm.controls['cantDispPlantaTercerCuota'].setValue(data[0]?.cuotasPlanta?.[2]?.cantidadDisponibleVenta ?? 0);
                this.itemForm.controls['fechaPrimerCuotaPlanta'].setValue(data[0]?.cuotasPlanta[0]?.fecha ?? new Date());
                this.itemForm.controls['fechaSegundaCuotaPlanta'].setValue(data[0]?.cuotasPlanta[1]?.fecha ?? new Date());
                this.itemForm.controls['fechaTercerCuotaPlanta'].setValue(data[0]?.cuotasPlanta[2]?.fecha ?? new Date());
              }
              else {
                this.mesAnioPrimerCuotaPlanta = "";
                this.mesAnioSegundaCuotaPlanta = "";
                this.mesAnioTercerCuotaPlanta = "";
              }

              if (data[0].cuotasDistribuidor.length) {

                this.mesAnioPrimerCuotaDistribuidor = data[0].cuotasDistribuidor[0] != null ? `${meses[parseInt(data[0].cuotasDistribuidor[0].mes, 10) - 1]}` : '';
                this.mesAnioSegundaCuotaDistribuidor = data[0].cuotasDistribuidor[1] != null ? `${meses[parseInt(data[0].cuotasDistribuidor[1].mes, 10) - 1]}` : '';
                this.mesAnioTercerCuotaDistribuidor = data[0].cuotasDistribuidor[2] != null ? `${meses[parseInt(data[0].cuotasDistribuidor[2].mes, 10) - 1]}` : '';
                // this.mesAnioPrimerCuotaDistribuidor = data[0].cuotasDistribuidor[0] != null ? data[0].cuotasDistribuidor[0].mes + "/" + data[0].cuotasDistribuidor[0].anio : "";
                // this.mesAnioSegundaCuotaDistribuidor = data[0].cuotasDistribuidor[1] != null ? data[0].cuotasDistribuidor[1].mes + "/" + data[0].cuotasDistribuidor[1].anio : "";
                // this.mesAnioTercerCuotaDistribuidor = data[0].cuotasDistribuidor[2] != null ? data[0].cuotasDistribuidor[2].mes + "/" + data[0].cuotasDistribuidor[2].anio : "";
                if (data[0].cuotasDistribuidor[0] != null) {
                  this.updateDateRangePrimerCuota(data[0].cuotasDistribuidor[0].mes + "-" + data[0].cuotasDistribuidor[0].anio);
                }
                if (data[0].cuotasDistribuidor[1] != null) {
                  this.updateDateRangeSegundaCuota(data[0].cuotasDistribuidor[1].mes + "-" + data[0].cuotasDistribuidor[1].anio);
                }
                if (data[0].cuotasDistribuidor[2] != null) {
                  this.updateDateRangeTercerCuota(data[0].cuotasDistribuidor[2].mes + "-" + data[0].cuotasDistribuidor[2].anio);
                }


                this.itemForm.controls['cantDispDistribuidorPrimerCuota'].setValue(data[0]?.cuotasDistribuidor[0]?.cantidadDisponibleVenta ?? 0);
                this.itemForm.controls['cantDispDistribuidorSegundaCuota'].setValue(data[0]?.cuotasDistribuidor[1]?.cantidadDisponibleVenta ?? 0);
                this.itemForm.controls['cantDispDistribuidorTercerCuota'].setValue(data[0]?.cuotasDistribuidor[2]?.cantidadDisponibleVenta ?? 0);
                // this.itemForm.controls['fechaPrimerCuotaDistribuidor'].setValue(data[0]?.cuotasDistribuidor[0]?.fecha ?? new Date());
                // this.itemForm.controls['fechaSegundaCuotaDistribuidor'].setValue(data[0]?.cuotasDistribuidor[1]?.fecha ?? new Date());
                // this.itemForm.controls['fechaTercerCuotaDistribuidor'].setValue(data[0]?.cuotasDistribuidor[2]?.fecha ?? new Date());
              }
              else {
                this.mesAnioPrimerCuotaDistribuidor = "";
                this.mesAnioSegundaCuotaDistribuidor = "";
                this.mesAnioTercerCuotaDistribuidor = "";
              }
            }
            this.itemForm.controls['cantidadComprada'].setValue(null);

            this.itemForm.markAsUntouched();
            this.itemForm.markAsPristine();
          }

        })

    }
    else {
      this.itemForm.controls['idProducto'].reset();
      this.itemForm.controls['producto'].reset();
      this.itemSeleccionado = null;
    }
  }
  seleccionarPlantaItem(pI: any) {

    this.storagesLocations = []
    this.plantaItemSeleccionada = null;
    this.limpiarItem(true);
    if (pI != null) {
      this.plantaItemSeleccionada = this.plantasItem.find(c => c.idPlanta == pI);
      if (this.plantaItemSeleccionada != null) {
        this.itemForm.controls['planta'].setValue(this.plantaItemSeleccionada.descripcion);

        this.pepService.cStoragesLocationsPlanta(this.plantaItemSeleccionada.idPais, this.plantaItemSeleccionada.idCompania, this.plantaItemSeleccionada.idSalesOrg, this.plantaItemSeleccionada.idPlanta)
          .subscribe((data: UbicacionAlmacenamiento[]) => {

            if (data != null) {
              this.storagesLocations = data;

            }

          })
        this.cabForm.markAllAsTouched();
      }
    }
    else {
      this.itemForm.controls['planta'].reset();
      this.itemForm.controls['idPlanta'].reset();

    }

  }

  seleccionarStorageLocation(sl: any) {
    this.limpiarItem(true);
    this.slSeleccionado = null;
    if (sl != null) {
      this.slSeleccionado = this.storagesLocations.find(c => c.id == this.itemForm.controls['idUbicacionAlmacenamiento'].value);
    }

  }

  calcularCantidadComprada() {
    this.cantidadCompradaAcumuldada = 0;
    this.cantidadCompradaAcumuldada =
      (this.itemForm.controls['cantidadDistribuidor'].value != null ? +this.itemForm.controls['cantidadDistribuidor'].value : 0) +
      (this.itemForm.controls['cantDistribuidorPrimerCuota'].value != null ? +this.itemForm.controls['cantDistribuidorPrimerCuota'].value : 0) +
      (this.itemForm.controls['cantDistribuidorSegundaCuota'].value != null ? +this.itemForm.controls['cantDistribuidorSegundaCuota'].value : 0) +
      (this.itemForm.controls['cantDistribuidorTercerCuota'].value != null ? +this.itemForm.controls['cantDistribuidorTercerCuota'].value : 0) +
      (this.itemForm.controls['cantidadPlanta'].value != null ? +this.itemForm.controls['cantidadPlanta'].value : 0) +
      (this.itemForm.controls['cantPlantaPrimerCuota'].value != null ? +this.itemForm.controls['cantPlantaPrimerCuota'].value : 0) +
      (this.itemForm.controls['cantPlantaSegundaCuota'].value != null ? +this.itemForm.controls['cantPlantaSegundaCuota'].value : 0) +
      (this.itemForm.controls['cantPlantaTercerCuota'].value != null ? +this.itemForm.controls['cantPlantaTercerCuota'].value : 0);
    this.itemForm.controls['cantidadComprada'].setValue(parseFloat(this.cantidadCompradaAcumuldada.toFixed(3)));
    this.itemForm.controls['cantidadComprada'].markAsTouched();
  }

  seleccionarDirEntrega(de: any, idSucursal: string) {

    this.seleccionarDireccion(null);

    this.dirEntregaSeleccionada = null;
    if (de != null) {
      this.dirEntregaSeleccionada = this.dirEntregas.find(c => c.nroCliente == this.cabForm.controls['nroClienteDireccionEntrega'].value);
      if (this.dirEntregaSeleccionada != null) {
        this.cabForm.controls['calleNroDireccionEntrega'].setValue(this.dirEntregaSeleccionada.calleNro);
        this.cabForm.controls['ciudadDireccionEntrega'].setValue(this.dirEntregaSeleccionada.ciudad);
        this.cabForm.controls['cpDireccionEntrega'].setValue(this.dirEntregaSeleccionada.codigoPostal);
        this.cabForm.controls['nombreClienteDireccionEntrega'].setValue(this.dirEntregaSeleccionada.nombre);
        this.cabForm.controls['nroClienteDireccionEntrega'].setValue(this.dirEntregaSeleccionada.nroCliente);

        this.cotizacionesService.cSucursales(this.dirEntregaSeleccionada.nroCliente)
          .subscribe((data2: Cuenta[]) => {
            // console.log(data2);
            if (data2 != null) {
              this.direcciones = data2;
              this.cabForm.controls['idSucursal'].setValue(this.direcciones[0].nroCliente);
              this.seleccionarDireccion(this.cabForm.controls['idSucursal'].value)

              if (idSucursal != null) {
                this.cabForm.controls['idSucursal'].setValue(idSucursal);
                this.seleccionarDireccion(this.cabForm.controls['idSucursal'].value)
              }
            }

          })
      }

    } else {
      this.cabForm.controls['calleNroDireccionEntrega'].reset();
      this.cabForm.controls['ciudadDireccionEntrega'].reset();
      this.cabForm.controls['cpDireccionEntrega'].reset();
      this.cabForm.controls['nombreClienteDireccionEntrega'].reset();
      this.cabForm.controls['nroClienteDireccionEntrega'].reset();
    }

  }

  scrollToAviso(avisoId: string): void {
    const avisoElement = document.getElementById(avisoId);
    if (avisoElement) {
      avisoElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  nuevoItem() {

    if (this.itemSeleccionado.unidadesPallet === 0) {
      this.avisoUnidadesPallet = true;
      this.mensajeUnidadesPallet = "No existen Kg/Litros para el producto";
    } else {
      this.avisoUnidadesPallet = false;
      const unidadesPallet = this.itemSeleccionado.unidadesPallet;

      const verificarMultiplo = (cantidad: number, aviso: string, mensaje: string) => {
        if (cantidad > 0) {
          const esMultiplo = Math.abs(cantidad / unidadesPallet - Math.round(cantidad / unidadesPallet)) < 1e-10;
          const valornum = Math.floor(cantidad / unidadesPallet) + 1;

          if (!esMultiplo) {
            this[aviso] = true;
            this[mensaje] = "La cantidad no corresponde a los Kg/Litros (" + unidadesPallet.toString() + "), cantidad sugerida: "
              + parseFloat((unidadesPallet * (valornum - 1)).toFixed(3)).toString() + " ó "
              + parseFloat((unidadesPallet * valornum).toFixed(3)).toString();
          } else {
            this[aviso] = false;
          }
        } else {
          this[aviso] = false;
        }
      };

      const cantidadDistribuidor = this.itemForm.controls['cantidadDistribuidor'].value;
      verificarMultiplo(cantidadDistribuidor, 'avisoUnidadesPalletDistribuidor', 'mensajeUnidadesPalletDistribuidor');
      if (this.avisoUnidadesPalletDistribuidor) {
        this.scrollToAviso('avisoUnidadesPalletDistribuidor');
      }
      const cantidadPrimerCuotaDistr = this.itemForm.controls['cantDistribuidorPrimerCuota'].value;
      verificarMultiplo(cantidadPrimerCuotaDistr, 'avisoUnidadesPalletDistribuidorPrimerCuota', 'mensajeUnidadesPalletDistribuidorPrimerCuota');
      if (this.avisoUnidadesPalletDistribuidorPrimerCuota) {
        this.scrollToAviso('avisoUnidadesPalletDistribuidorPrimerCuota');
      }
      const cantidadSegundaCuotaDistr = this.itemForm.controls['cantDistribuidorSegundaCuota'].value;
      verificarMultiplo(cantidadSegundaCuotaDistr, 'avisoUnidadesPalletDistribuidorSegundaCuota', 'mensajeUnidadesPalletDistribuidorSegundaCuota');
      if (this.avisoUnidadesPalletDistribuidorSegundaCuota) {
        this.scrollToAviso('avisoUnidadesPalletDistribuidorSegundaCuota');
      }
      const cantidadTercerCuotaDistr = this.itemForm.controls['cantDistribuidorTercerCuota'].value;
      verificarMultiplo(cantidadTercerCuotaDistr, 'avisoUnidadesPalletDistribuidorTercerCuota', 'mensajeUnidadesPalletDistribuidorTercerCuota');
      if (this.avisoUnidadesPalletDistribuidorTercerCuota) {
        this.scrollToAviso('avisoUnidadesPalletDistribuidorTercerCuota');
      }
      const cantidadPlanta = this.itemForm.controls['cantidadPlanta'].value;
      verificarMultiplo(cantidadPlanta, 'avisoUnidadesPalletPlanta', 'mensajeUnidadesPalletPlanta');
      if (this.avisoUnidadesPalletPlanta) {
        this.scrollToAviso('avisoUnidadesPalletPlanta');
      }
      const cantidadPrimerCuotaPlanta = this.itemForm.controls['cantPlantaPrimerCuota'].value;
      verificarMultiplo(cantidadPrimerCuotaPlanta, 'avisoUnidadesPalletPlantaPrimerCuota', 'mensajeUnidadesPalletPlantaPrimerCuota');
      if (this.avisoUnidadesPalletPlantaPrimerCuota) {
        this.scrollToAviso('avisoUnidadesPalletPlantaPrimerCuota');
      }
      const cantidadSegundaCuotaPlanta = this.itemForm.controls['cantPlantaSegundaCuota'].value;
      verificarMultiplo(cantidadSegundaCuotaPlanta, 'avisoUnidadesPalletPlantaSegundaCuota', 'mensajeUnidadesPalletPlantaSegundaCuota');
      if (this.avisoUnidadesPalletPlantaSegundaCuota) {
        this.scrollToAviso('avisoUnidadesPalletPlantaSegundaCuota');
      }
      const cantidadTercerCuotaPlanta = this.itemForm.controls['cantPlantaTercerCuota'].value;
      verificarMultiplo(cantidadTercerCuotaPlanta, 'avisoUnidadesPalletPlantaTercerCuota', 'mensajeUnidadesPalletPlantaTercerCuota')
      if (this.avisoUnidadesPalletPlantaTercerCuota) {
        this.scrollToAviso('avisoUnidadesPalletPlantaTercerCuota');
      }
    }

    if (this.avisoUnidadesPallet || this.avisoUnidadesPalletDistribuidor || this.avisoUnidadesPalletDistribuidorPrimerCuota
      || this.avisoUnidadesPalletDistribuidorSegundaCuota || this.avisoUnidadesPalletDistribuidorTercerCuota || this.avisoUnidadesPalletPlanta
      || this.avisoUnidadesPalletPlantaPrimerCuota || this.avisoUnidadesPalletPlantaSegundaCuota || this.avisoUnidadesPalletPlantaTercerCuota) {
      this.aviso = true;
    } else this.aviso = false;

    this.itemForm.get('cantidadComprada').setValidators([Validators.required, Validators.min(0.001)]);
    this.itemForm.get('cantidadComprada').updateValueAndValidity();
    if (this.itemSeleccionado == null && this.cabForm.valid) {
      this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, "Seleccioná un ítem.", 2, 2);
    }
    this.itemForm.markAllAsTouched();

    if (this.cabForm.valid && this.itemForm.valid && !this.aviso) {

      if (!this.itemForm.value.fechaPrimerCuotaDistribuidor) {
        this.itemForm.controls['fechaPrimerCuotaDistribuidor'].setValue(new Date());
      }
      if (!this.itemForm.value.fechaSegundaCuotaDistribuidor) {
        this.itemForm.controls['fechaSegundaCuotaDistribuidor'].setValue(new Date());
      }
      if (!this.itemForm.value.fechaTercerCuotaDistribuidor) {
        this.itemForm.controls['fechaTercerCuotaDistribuidor'].setValue(new Date());
      }
      let i: PedidoVentaItem[] = []
      i.push(this.itemForm.value);
      this.cabForm.controls['items'].setValue(i);
      this.itemForm.controls['autor'].setValue(this.loggedService.logged.userName);

      // console.log(this.cabForm.value)
      this.cotizacionesService
        .aCotizacionItem(this.cabForm.value)
        .subscribe((data: CotizacionCabecera) => {
          if (data != null) {
            this.cabForm.controls['aprobar'].setValue(data.aprobar);
            this.cabForm.controls['aprobarReservado'].setValue(data.aprobarReservado);
            this.cabForm.controls['borrador'].setValue(data.borrador);
            this.cabForm.controls['aprobarParcial'].setValue(data.aprobarParcial);
            this.cabForm.controls['rechazar'].setValue(data.rechazar);

            this.limpiarItem(true);
            if (this.codigoEdit == 0) {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 2);
            }
            else {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 2);
            }
            if (data.items != null) {
              if (data.items.length) {
                this.dataSourceItems.data = data.items;
                this.totalItems = this.dataSourceItems.data.map(a => a.total).reduce(function (a, b) {
                  return a + b;
                });
                this.cDescuentosDiscrecionalesNegativos();

              }
            }
            this.dataSourceItemsDescuentos.data = [];
            if (data.itemsDescuento != null) {
              if (data.itemsDescuento.length) {
                this.dataSourceItemsDescuentos.data = data.itemsDescuento;
              }
            }
            this.codigoEdit = data.codigo;
            this.cabForm.controls['codigo'].setValue(this.codigoEdit);
            this.cabForm.controls['items'].reset();

            this.idTipo == 2
            this.itemForm.markAsUntouched();
            //console.log(data);
          }

        })
    }
    else {
      if ((!this.cabForm.valid && this.itemForm.valid) || (!this.cabForm.valid && !this.itemForm.valid)) {
        this.scrollToInvalidFormControls(this.cabForm);
      }
      else {
        this.scrollToInvalidFormControls(this.itemForm);
      }
    }


  }

  cDescuentosDiscrecionalesNegativos() {
    this.descuentosDiscrecionalesNegativos = false;
    this.itemsConDescuentoDiscrecionalNegativo = [];
    if (this.cabForm.controls['descuentoDiscrecional'].value < 0) {
      this.descuentosDiscrecionalesNegativos = true;
    }
    this.dataSourceItems.data.forEach(item => {
      if (item.descuentoDiscrecional < 0) {
        this.descuentosDiscrecionalesNegativos = true;
        this.itemsConDescuentoDiscrecionalNegativo.push(item);
      }
    });
  }

  dialogItem(item: CotizacionItem) {

    if (this.lpSeleccionada != null) {

      this.productosService.cListaPrecioCabeceraDB(this.lpSeleccionada.codigo).subscribe((data: ListaPrecioCabecera) => { //Buscar la lp del pedido para ver si tiene precio fijo antes de editar el item
        if (data != null) {
          this.lpSeleccionada = data;
          this.cabForm.controls['preciosFijos'].setValue(this.lpSeleccionada.precioFijo);
          let config: MatDialogConfig = new MatDialogConfig();
          config.width = '100%';
          config.height = 'auto';
          let cab: CotizacionCabecera = this.cabForm.value;
          let i: CotizacionItem = structuredClone(item);
          cab.items = [];
          cab.items.push(i);
          config.data = { cab: cab }
          let dialogRef = this.dialog.open(CotizacionItemDialogComponent, config);
          let idCompania: string = this.cabForm.controls['idCompania'].value;
          let idSalesOrg: string = this.cabForm.controls['idSalesOrg'].value;

          dialogRef.afterClosed().subscribe((data: number) => {
            if (data != 0) {
              this.cotizacionesService.cCotizacion(this.codigoEdit).subscribe((data: CotizacionCabecera) => {
                if (data != null) {

                  this.limpiarItem(true);
                  this.dataSourceItems.data = [];
                  this.totalItems = 0;
                  if (data.items != null) {
                    if (data.items.length) {
                      this.dataSourceItems.data = data.items;
                      this.totalItems = this.dataSourceItems.data.map(a => a.total).reduce(function (a, b) {
                        return a + b;
                      });
                      this.cDescuentosDiscrecionalesNegativos();

                    }
                  }
                  this.dataSourceItemsDescuentos.data = [];
                  if (data.itemsDescuento != null) {
                    if (data.itemsDescuento.length) {
                      this.dataSourceItemsDescuentos.data = data.itemsDescuento;
                    }
                  }
                  this.cabForm.controls['descuentoDiscrecional'].setValue(data.descuentoDiscrecional);
                  this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 2);
                }

              })
            }
          })
        }

      })

    }

  }

  eliminarItem(item: CotizacionItem) {
    this.dialog
      .open(ConfirmacionDialogComponent, { panelClass: 'app-dialog', data: "¿Confirmas la eliminación del producto " + item.idProducto + " - " + item.producto + "?", width: 'auto', height: 'auto' })
      .afterClosed()
      .subscribe((Si: boolean) => {
        if (Si) {
          this.cotizacionesService.bCotizacionitem(this.codigoEdit, item.codigo).subscribe((data: CotizacionCabecera) => {

            if (data != null) {

              this.limpiarItem(true);

              this.dataSourceItems.data = [];
              this.totalItems = 0;
              if (data.items != null) {
                if (data.items.length) {
                  this.dataSourceItems.data = data.items;
                  this.totalItems = this.dataSourceItems.data.map(a => a.total).reduce(function (a, b) {
                    return a + b;
                  });
                  this.cDescuentosDiscrecionalesNegativos();
                }
              }
              this.dataSourceItemsDescuentos.data = [];
              if (data.itemsDescuento != null) {
                if (data.itemsDescuento.length) {
                  this.dataSourceItemsDescuentos.data = data.itemsDescuento;
                }
              }
              this.cabForm.controls['aplicaDescDisc'].setValue(data.aplicaDescDisc);
              this.cabForm.controls['aplicaDtoDiscrecionalxLP'].setValue(data.aplicaDtoDiscrecionalxLP);
              this.cabForm.controls['aplicaPrecioFijoxLP'].setValue(data.aplicaPrecioFijoxLP);
              this.cabForm.controls['aprobar'].setValue(data.aprobar);
              this.cabForm.controls['aprobarParcial'].setValue(data.aprobarParcial);
              this.cabForm.controls['aprobarReservado'].setValue(data.aprobarReservado);
              this.cabForm.controls['borrador'].setValue(data.borrador);
              this.cabForm.controls['rechazar'].setValue(data.rechazar);
              this.cabForm.controls['descuentoCategoria'].setValue(data.descuentoCategoria);
              this.cabForm.controls['descuentoDiscrecional'].setValue(data.descuentoDiscrecional);
              this.cabForm.controls['preciosFijos'].setValue(data.preciosFijos);
              this.cabForm.controls['recargo'].setValue(data.recargo);
              this.cabForm.controls['recargoLocal'].setValue(data.recargoLocal);
              this.cabForm.controls['items'].reset();
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.EliminacionExitosa, 1, 2);
            }
          })
        }
      })
  }

  dialogRetenciones() {
    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { cab: this.cabForm.value }
    let dialogRef = this.dialog.open(CotizacionRetencionesDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: string) => {

    })
  }

  dialogLogAutorizaciones() {
    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { cab: this.cabForm.value }
    let dialogRef = this.dialog.open(CotizacionLogsDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: string) => {

    })
  }

  dialogAprobacionRetenido() {

    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { cab: this.cabForm.value }
    let dialogRef = this.dialog.open(CotizacionAprobacionRetenidaDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: CotizacionCabecera) => {
      if (data != null && typeof data != 'undefined') {
        if (typeof data != 'string') {

          //this.cabForm.controls['comentarioLogAutorizacion'].setValue(data.comentarioLogAutorizacion);
          //this.cabForm.controls['idMotivoRetencion'].setValue(data.idMotivoRetencion);
          this.cabForm.controls['codigosRetencionesAprobadas'].setValue(data.codigosRetencionesAprobadas);
          //console.log(this.cabForm.controls['comentarioLogAutorizacion'].value);
          this.cotizacionesService.aprobarCotizacionRetenida(this.cabForm.value).subscribe((data: CotizacionCabecera) => {
            if (data != null) {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AprobacionPedidoExitosa, 1, 2);
              this.regresarALaRutaAnterior();
            }
          });
        }


      }
    })
  }

  dialogComentario(idTipo: number, required: boolean) {
    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { required: required }
    let dialogRef = this.dialog.open(ComentarioPedidoDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: string) => {
      if (data != null && typeof data != 'undefined') {
        this.cabForm.controls['comentarioLogAutorizacion'].setValue(data);

        switch (idTipo) {
          case 1: //Aprobar 
            this.cotizacionesService.aprobarCotizacion(this.cabForm.value).subscribe((data: CotizacionCabecera) => {
              if (data != null) {
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AprobacionPedidoExitosa, 1, 2);
                this.regresarALaRutaAnterior();
              }
            })
            break;
          case 2: //Rechazar

            this.cotizacionesService.rechazarCotizacion(this.cabForm.value).subscribe((data: CotizacionCabecera) => {
              if (data != null) {
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.RechazoPedidoExitoso, 1, 2);
                this.regresarALaRutaAnterior();
              }
            })
            break;
          case 3:
            this.cotizacionesService.aprobarCotizacionRetenida(this.cabForm.value).subscribe((data: CotizacionCabecera) => {
              if (data != null) {
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AprobacionPedidoExitosa, 1, 2);
                this.regresarALaRutaAnterior();
              }
            });

            //Rechazar cotización (Rechazar pedido por cliente)

            /*this.cotizacionesService.rechazarPedidoEspecialPlantaPorCliente(this.cabForm.value).subscribe((data: CotizacionCabecera) => {
              if (data != null) {
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.RechazoPedidoExitoso, 1, 2);

                this.volver();
              }

            })*/

            break;

          case 4: //Aprobar Cotizacion

            this.cotizacionesService.procesarCotizacion(this.cabForm.value.nroPedido).subscribe((data: CotizacionCabecera) => {
              if (data != null) {
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AprobacionPedidoExitosa, 1, 2);
                this.regresarALaRutaAnterior();
              }
            });

            break;
          case 5: //Aprobar Cotizacion

            this.cotizacionesService.rechazar(this.cabForm.value).subscribe((data: CotizacionCabecera) => {
              if (data != null) {
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.RechazoPedidoExitoso, 1, 2);
                this.regresarALaRutaAnterior();
              }

            });

            break;
        }


      }
    })
  }

  dialogNroOC() {
    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { cab: this.cabForm.value }
    let dialogRef = this.dialog.open(NroOCDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: string) => {
      if (data != null && typeof data != 'undefined') {
        this.cabForm.controls['nroOC'].setValue(data);
        this.cotizacionesService.guardarNroOC(this.cabForm.value).subscribe((data: CotizacionCabecera) => {
          if (data != null) {
            this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, "Nro. de orden de compra guardado", 1, 2);
          }
        })
      }
    })
  }

  volver() {
    this.router.navigateByUrl(this.configService.etiquetas.Cotizaciones.Buscador.Path);
  }
  regresarALaRutaAnterior() {
    if (this.router.lastSuccessfulNavigation.extras.replaceUrl == undefined || this.router.lastSuccessfulNavigation.extras.replaceUrl) {
      var state = this.router.lastSuccessfulNavigation.extras.state;
      if (state) {
        this.router.navigateByUrl(state.rutaAnterior || '/');
      }
      else {
        this.volver();
      }
    }
    else {
      this.volver();
    }
  }
  compareCompanias(compLista: any, compPV: any): boolean {
    return compLista === compPV;
  }

  compareTerminosPago(tpLista: any, tpPV: any): boolean {
    return tpLista === tpPV;
  }

  compareSalesOrgs(salesOrgLista: any, salesOrgPV: any): boolean {
    return salesOrgLista == salesOrgPV;
  }
  compareDivisiones(dLista: any, dPV: any): boolean {
    return dLista == dPV;
  }

  compareGC(gcLista: any, gcPV: any): boolean {
    return gcLista == gcPV;
  }

  compareRegiones(rLista: any, rPV: any): boolean {
    return rLista == rPV;
  }

  compareMonedas(mLista: any, mPV: any): boolean {
    return mLista == mPV;
  }

  compareDirecciones(dLista: any, dPV: any): boolean {
    return dLista == dPV;
  }
  compareCuentasDistribuidores(dLista: any, dPV: any): boolean {
    return dLista == dPV;
  }

  comparePlantas(pLista: any, pPEP: any): boolean {
    return pLista === pPEP;
  }
  compareStoragesLocations(slLista: any, slPEP: any): boolean {
    return slLista === slPEP;
  }
  compareDireccionEntrega(deLista: any, de: any): boolean {
    return deLista === de;
  }
  compareLPs(lpLista: any, lp: any): boolean {
    return lpLista === lp;
  }
  clasePorEstado(id: string) {
    let clase = ClasePorEstado("1", id);
    return clase;
  }

  scrollToInvalidFormControls(fg: FormGroup) {
    scrollToInvalidFromControls(this.cotizacion, fg);
  }

  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }

  checkCantidad(formControl: any) { //Para evitar que un formcontrol quede en blanco o null

    if (!this.itemForm.get(formControl).value) {
      this.itemForm.get(formControl).setValue(0, { onlySelf: true, emitEvent: false }); // Esto es para poner su valor en 0 si se queda en blanco, sin disparar valueChanges
    }
  }


  pruebaMailCot() {
    this.cotizacionesService.pruebaMailCot(this.cabForm.value.nroPedido).subscribe({
      next: (response: any) => {
        this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, response.mensaje, 1, 1);

        console.log('Respuesta del servidor:', response);
      },
      error: (error) => {
        this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, 'Error al enviar el correo electrónico', 0, 1);
        console.error('Error al enviar la solicitud:', error);
      }
    });
  }

  // async generatePDF(): Promise<Blob> {
  //   try {
  //     const cabValues = this.cabForm.value;
  //     const itemValues = this.dataSourceItems.data;

  //     // Esperar a obtener los datos del cliente
  //     const datac: DataClientePedidos = await this.admService.cDataClienteSeleccionadoAwait(
  //       cabValues.idPais,
  //       cabValues.idCompania,
  //       cabValues.idSalesOrg,
  //       cabValues.idDivision,
  //       cabValues.nroCliente
  //     );

  //     // Mapeo a un formato consistente para manipulación
  //     const items = itemValues.map(item => ({
  //       cantidad: item.cantidad,
  //       idProducto: item.idProducto,
  //       nroClienteDireccionEntrega: item.nroClienteDireccionEntrega,
  //       direccionEntrega: item.calleNroDireccionEntrega + ', ' + item.ciudadDireccionEntrega,
  //       fechaEntrega: new Date(item.fechaEntrega),
  //       producto: item.producto,
  //       esDistribuidor: item.itemDistribuidor,
  //       precioUnitarioFinal: item.precioUnitarioFinal,
  //       total: item.total
  //     }));

  //     // Calcular la suma total de precioUnitarioFinal
  //     const totalPrecioUnitarioFinal = items.reduce((acc, item) => acc + item.total, 0);

  //     // Agrupar y sumarizar datos
  //     const groupedItems = items.reduce((acc, item) => {
  //       const key = `${item.idProducto}-${item.nroClienteDireccionEntrega}-${item.fechaEntrega}`;
  //       if (!acc[key]) {
  //         acc[key] = {
  //           cantidad: 0,
  //           precioUnitarioFinal: 0,
  //           total: 0,
  //           producto: item.producto,
  //           nroClienteDireccionEntrega: item.nroClienteDireccionEntrega,
  //           fechaEntrega: item.fechaEntrega,
  //           direccionEntrega: item.direccionEntrega
  //         };
  //       }
  //       acc[key].cantidad += item.cantidad;
  //       acc[key].precioUnitarioFinal = item.precioUnitarioFinal;
  //       acc[key].total += item.total;

  //       return acc;
  //     }, {} as {
  //       [key: string]: {
  //         cantidad: number;
  //         precioUnitarioFinal: number;
  //         total: number;
  //         producto: string;
  //         nroClienteDireccionEntrega: string;
  //         direccionEntrega: string;
  //         fechaEntrega: Date;
  //       }
  //     });

  //     // Transformar los datos agrupados en un array compatible con autoTable
  //     const dataItems = Object.entries(groupedItems).map(([key, { producto, cantidad, precioUnitarioFinal, total, nroClienteDireccionEntrega, fechaEntrega, direccionEntrega }]) => [
  //       cantidad.toLocaleString('es-ES'),
  //       producto,
  //       fechaEntrega.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }),
  //       direccionEntrega,
  //       precioUnitarioFinal.toLocaleString('es-ES', { minimumFractionDigits: 2 }),
  //       total.toLocaleString('es-ES', { minimumFractionDigits: 2 })
  //     ]);

  //     // Esperar a obtener la imagen en base64
  //     const logoBase64: string = await this.imageService.getImageBase64('assets/images/logo_bayer.png').toPromise();

  //     const doc = new jsPDF();
  //     doc.addFileToVFS("Roboto-Regular.ttf", "base64-encoded-string-of-your-font");
  //     doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
  //     doc.setFont("Roboto");

  //     // Datos de ejemplo
  //     const header = 'Cotización';
  //     const companyName = 'Bayer S.A.';
  //     const companyAddress = 'Av. Andrés Bello N° 2457,\n Providencia,\n Santiago de Chile';
  //     const companyPhone = '+56 2 520-8200';
  //     const quoteNumber = cabValues.nroPedido;
  //     const quoteDate = new Date(cabValues.fechaCreacion).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
  //     const clientId = cabValues.nroCliente;
  //     const cliente = cabValues.nombreCliente;
  //     const rut = cabValues.cuit;
  //     const diasVencimiento = this.diasCotizacionRechazada[0].descripcion;
  //     const diasVencimientoInt = parseInt(diasVencimiento, 10);
  //     const validUntil = new Date(cabValues.fechaCreacion);
  //     validUntil.setDate(validUntil.getDate() + diasVencimientoInt);
  //     const vendorName = cabValues.idZonaVendedor;
  //     const paymentTerms = cabValues.terminoPago;
  //     const subtotal = totalPrecioUnitarioFinal;
  //     const iva = (totalPrecioUnitarioFinal * 0.19);
  //     const total = (totalPrecioUnitarioFinal + iva).toFixed(2);
  //     const exchangeRate = cabValues.tipoCambio;
  //     const totalCLP = (subtotal * exchangeRate).toFixed(2);

  //     // Añadir imagen
  //     const imageWidth = 30;
  //     const imageHeight = 30;
  //     doc.addImage(logoBase64, 'PNG', 10, 10, imageWidth, imageHeight);

  //     // Título
  //     doc.setFontSize(18);
  //     doc.text(header, 105, 10, { align: 'center' });

  //     // Información de la empresa
  //     const textStartX = 50;
  //     const textStartY = 20;
  //     doc.setFontSize(8);
  //     doc.text(`${companyName}\n${companyAddress}\n${companyPhone}`, textStartX, textStartY);

  //     doc.setFontSize(8);
  //     doc.text(`N° Cotización: ${quoteNumber}\nFECHA: ${quoteDate}\nId. del cliente: ${clientId}`, 150, textStartY);

  //     let direccionCliente = datac.cuenta.calleNro;
  //     let ciudadCliente = datac.cuenta.ciudad;
  //     let telefonoCliente = datac.cuenta.telefono ?? "";
  //     const additionalInfoStartY = 60;

  //     (doc as any).autoTable({
  //       body: [
  //         ['Presupuesto para: '],
  //         [`RUT: ${rut}`],
  //         [`Nombre de la empresa: ${cliente}`],
  //         [`Dirección: ${direccionCliente}`],
  //         [`Ciudad: ${ciudadCliente}`],
  //         [`Teléfono: ${telefonoCliente}`],
  //       ],
  //       theme: 'plain',
  //       startY: additionalInfoStartY,
  //       margin: { left: 10 },
  //       styles: { lineHeight: 0.5 },
  //       tableWidth: 90
  //     });

  //     const finalInfoCliente = (doc as any).lastAutoTable.finalY;
  //     const finalInfoY = (doc as any).lastAutoTable.finalY;

  //     // Información adicional
  //     (doc as any).autoTable({
  //       body: [
  //         [`Cotización válida hasta: ${validUntil.toLocaleDateString()}`],
  //         [`Vendedor Bayer: ${vendorName}`],
  //         [`Condición de Pago: ${paymentTerms}`]
  //       ],
  //       theme: 'plain',
  //       startY: additionalInfoStartY,
  //       margin: { left: 100 },
  //       tableWidth: 90
  //     });

  //     doc.setFontSize(12);
  //     doc.text(`Comentarios o instrucciones especiales: ${cabValues.glosa}`, 15, finalInfoCliente + 5);

  //     // Tabla de productos utilizando autoTable
  //     const tableStartY = additionalInfoStartY + 60;
  //     (doc as any).autoTable({
  //       head: [['CANTIDAD', 'PRODUCTO', 'FECHA DE ENTREGA', 'DIRECCION DE ENTREGA', 'PRECIO USD', 'NETO USD']],
  //       body: dataItems,
  //       startY: finalInfoY + 10,
  //       margin: { left: 10 },
  //       columnStyles: {
  //         0: { halign: 'right' },
  //         4: { halign: 'right' },
  //         5: { halign: 'right' },
  //       }
  //     });

  //     // Obtener la posición después de la tabla
  //     const finalY = (doc as any).lastAutoTable.finalY;

  //     // Totales
  //     doc.text(`SUBTOTAL: ${subtotal.toLocaleString('es-ES', { minimumFractionDigits: 2 })}`, 150, finalY + 10);
  //     doc.text(`IVA 19%: ${iva.toLocaleString('es-ES', { minimumFractionDigits: 2 })}`, 150, finalY + 15);
  //     doc.text(`TOTAL: ${parseFloat(total).toLocaleString('es-ES')}`, 150, finalY + 20);

  //     // Información adicional
  //     doc.text(`COTIZACIÓN EN CLP: ${parseFloat(totalCLP).toLocaleString('es-ES', { minimumFractionDigits: 2 })}`, 10, finalY + 10);
  //     doc.text(`TIPO DE CAMBIO DEL DÍA DE COTIZACIÓN: ${exchangeRate.toLocaleString('es-ES', { minimumFractionDigits: 2 })}`, 10, finalY + 20);

  //     const nombreDiscl = this.disclaimersCotizaciones[1].descripcion;
  //     const telefonoDiscl = this.disclaimersCotizaciones[0].descripcion;
  //     const emailDiscl = this.disclaimersCotizaciones[2].descripcion;
  //     const disclaimer = `Si tiene cualquier tipo de pregunta acerca de esta cotización póngase en contacto con, ${nombreDiscl}, ${telefonoDiscl}, ${emailDiscl}`;
  //     doc.text(disclaimer, 10, finalY + 45);

  //     // Pie de página
  //     doc.text('GRACIAS POR SU CONFIANZA.', 105, finalY + 80, { align: 'center' });

  //     // Convertir el PDF a Blob y devolverlo
  //     return doc.output('blob');

  //   } catch (error) {
  //     console.error('Error generating PDF:', error);
  //     throw error;
  //   }
  // }



}
